export const cityCoordinates = {
  'Aalborg': [57.0927589138, 9.84924316406],
  'Aarhus': [56.2999992371, 10.619000434899998],
  'Abadan': [30.371099472, 48.2282981873],
  'Abbeville': [50.143501, 1.831891],
  'Abbotsford': [49.025299072265625, -122.36100006103516],
  'Abeche': [13.847000122070312, 20.84429931640625],
  'Aberdeen': [57.201900482177734, -2.197779893875122],
  'Abha': [18.240400314299997, 42.65660095210001],
  'Abidjan': [5.261390209197998, -3.9262900352478027],
  'Abu Simbel': [22.375999450699997, 31.611700058],
  'Abuja': [9.006790161132812, 7.263169765472412],
  'Abumusa I.': [25.8757, 55.033001],
  'Acapulco': [16.757099151611328, -99.75399780273438],
  'Accra': [5.6037, -0.187],
  'Adana': [36.9822006226, 35.280399322499996],
  'Addis Ababa': [9.032, 38.7469],
  'Adrar': [27.837600708007812, -0.18641400337219238],
  'Afyon': [38.726398468, 30.6011009216],
  'Agadez': [16.965999603271484, 8.000109672546387],
  'Agadir': [30.325000762939453, -9.413069725036621],
  'Agen': [44.17470169067383, 0.5905560255050659],
  'Aggeneys': [-29.28179931640625, 18.813899993896484],
  'Aghajari': [30.7444, 49.6772],
  'Agrinion': [38.602001, 21.3512001],
  'Aguascalientes': [21.705601, -102.318001],
  'Ahwaz': [31.337400436399996, 48.7620010376],
  'Aioun El Atrouss': [16.711299896240234, -9.637880325317383],
  'Aitutaki': [-18.830900192260742, -159.76400756835938],
  'Ajaccio': [41.92359924316406, 8.8029203414917],
  'Akrotiri': [34.590401, 32.9879],
  'Akure': [7.246739864349365, 5.3010101318359375],
  'Akureyri': [65.66000366210938, -18.07270050048828],
  'Al Hociema': [35.177101135253906, -3.83951997756958],
  'Al-ahsa': [25.28529930114746, 49.485198974609375],
  'Albacete': [38.9485015869, -1.8635200262099998],
  'Albenga': [44.050598, 8.12743],
  'Albert': [49.9715003967, 2.69765996933],
  'Albi': [43.91389846801758, 2.1130599975585938],
  'Alderney': [49.706104, -2.21472],
  'Alert': [82.51779937740001, -62.2806015015],
  'Alesund': [62.5625, 6.119699954986572],
  'Alexander Bay': [-28.575001, 16.5333],
  'Alexandra': [-45.211700439453125, 169.3730010986328],
  'Alexandria': [31.183900833129883, 29.94890022277832],
  'Alexandroupolis': [40.855899810791016, 25.956300735473633],
  'Alghero': [40.632099, 8.29077],
  'Algier': [36.691001892089844, 3.215409994125366],
  'Alicante': [38.28219985961914, -0.5581560134887695],
  'Alice Town': [25.6998996735, -79.2647018433],
  'Almeria': [36.84389877319336, -2.3701000213623047],
  'Alta': [69.976097106934, 23.371700286865],
  'Altenburg': [50.981945, 12.506389],
  'Altenrhein': [47.4850006104, 9.560770034789998],
  'Alverca': [38.883301, -9.0301],
  'Ambilobe': [-13.188400268554688, 48.987998962402344],
  'Amilcar Cabral': [16.7414, -22.9494],
  'Ampampamena': [-13.484816, 48.632702],
  'Amsterdam': [52.3676, 4.9041],
  'Anaa': [-17.35260009765625, -145.50999450683594],
  'Analalava': [-14.62969970703125, 47.76380157470703],
  'Anchorage': [61.2181, -149.9003],
  'Andapa': [-14.651700019836426, 49.620601654052734],
  'Andoya': [69.292503356934, 16.144199371338],
  'Andravida': [37.9207, 21.292601],
  'Andros Town': [24.697900772094727, -77.79560089111328],
  'Angeles City': [15.145, 120.5887],
  'Angouleme': [45.72919845581055, 0.22145600616931915],
  'Anjouan': [-12.131699562072754, 44.430301666259766],
  'Ankara': [40.128101348899996, 32.995098114],
  'Annaba': [36.822201, 7.809174],
  'Annecy': [45.9308333, 6.1063889],
  'Annemasse': [46.1920013428, 6.268390178680001],
  'Antalaha': [-14.99940013885498, 50.3202018737793],
  'Antalya': [36.898701, 30.800501],
  'Antananarivo': [-18.7969, 47.478802],
  'Antsiranana': [-12.34939956665039, 49.29169845581055],
  'Antsohihy': [-14.898799896240234, 47.993900299072266],
  'Antwerp': [51.1893997192, 4.46027994156],
  'Arad': [46.17660140991211, 21.261999130249023],
  'Arar': [30.906600952148438, 41.13819885253906],
  'Arba Minch': [6.0393900871276855, 37.59049987792969],
  'Ardmore': [-37.029701232910156, 174.97300720214844],
  'Armstrong': [50.29029846191406, -88.90969848632812],
  'Arrecife': [28.945499, -13.6052],
  'Aruba': [12.5211, -69.9683],
  'Arusha': [-3.3677899837493896, 36.63330078125],
  'Arutua': [-15.248299598693848, -146.61700439453125],
  'Arvidsjaur': [65.59030151367188, 19.28190040588379],
  'Asosa': [10.018500328063965, 34.586299896240234],
  'Aswan': [23.9643993378, 32.8199996948],
  'Atar': [20.506799697875977, -13.04319953918457],
  'Athens': [37.9838, 23.7275],
  'Atikokan': [48.7738990784, -91.6386032104],
  'Atlanta': [33.749, -84.388],
  'Aubenas-vals-lanas': [44.544203, 4.372192],
  'Auckland': [-36.8485, 174.7633],
  'Augsburg': [48.425278, 10.931667],
  'Augusta': [33.4735, -82.0105],
  'Aurillac': [44.89139938354492, 2.4219400882720947],
  'Austin': [30.2672, -97.7431],
  'Auxerre': [47.85020065307617, 3.497109889984131],
  'Avarua': [-21.2026996613, -159.805999756],
  'Aviano': [46.031898, 12.596503],
  'Avignon': [43.90729904174805, 4.901830196380615],
  'Aviles': [43.5635986328125, -6.0346198081970215],
  'Axum': [14.14680004119873, 38.77280044555664],
  'Bacau': [46.52190017700195, 26.91029930114746],
  'Bacolod City': [10.676, 122.95],
  'Badajoz': [38.891300201416016, -6.8213300704956055],
  'Bafoussam': [5.536920070650001, 10.354599952700001],
  'Bagotville': [48.33060073852539, -70.99639892578125],
  'Baguio City': [16.4023, 120.596],
  'Bahar Dar': [11.608099937438965, 37.32160186767578],
  'Bahrain': [26.27079963684082, 50.63359832763672],
  'Baia Mare': [47.65840148925781, 23.469999313354492],
  'Baie Comeau': [49.13249969482422, -68.20439910888672],
  'Bakel': [14.847299575805664, -12.468299865722656],
  'Baker Lake': [64.29889678960001, -96.077796936],
  'Bakhtaran': [34.3459014893, 47.1581001282],
  'Balikesir': [39.619300842285156, 27.926000595092773],
  'Baltimore': [39.2904, -76.6122],
  'Bamako': [12.5335, -7.94994],
  'Bamenda': [6.039239883422852, 10.122599601745605],
  'Bandar Lengeh': [26.531999588, 54.824798584],
  'Bandar Mahshahr': [30.55620002746582, 49.15190124511719],
  'Bandirma': [40.31800079345703, 27.977699279785156],
  'Bandoundu': [-3.3113200664520264, 17.38170051574707],
  'Bangalore': [12.9716, 77.5946],
  'Bangkok': [13.7563, 100.5018],
  'Bangui': [4.39847993850708, 18.518800735473633],
  'Banjul': [13.338000297546387, -16.65220069885254],
  'Baracoa Playa': [20.365299224853516, -74.5062026977539],
  'Barahona': [18.25149917602539, -71.12039947509766],
  'Barcelona': [41.3851, 2.1734],
  'Bardufoss': [69.055801391602, 18.540399551392],
  'Bari': [41.138901, 16.760599],
  'Barrow Island': [54.1286111, -3.2675],
  'Barth': [54.338253, 12.710515],
  'Basco': [20.45, 121.9667],
  'Bastia': [42.55270004272461, 9.48373031616211],
  'Bata': [1.9054700136184692, 9.805680274963379],
  'Batman': [37.929000854499996, 41.1166000366],
  'Batsfjord': [70.60050201416, 29.691400527954],
  'Bayamo': [20.396400451660156, -76.62139892578125],
  'Bayreuth': [49.985001, 11.64],
  'Beauvais': [49.45439910888672, 2.1127800941467285],
  'Beer-sheba': [31.287000656128, 34.722999572754],
  'Beijing': [39.9042, 116.4074],
  'Beira': [-19.79640007019043, 34.90760040283203],
  'Beja (madeira)': [38.078899, -7.9324],
  'Bejaja': [36.7120018005, 5.0699200630200005],
  'Belfast': [54.6575012207, -6.2158298492399995],
  'Belgrade': [44.8184013367, 20.3090991974],
  'Belize City': [17.4995, -88.1976],
  'Ben Slimane': [33.655399, -7.22145],
  'Benbecula': [57.48109817504883, -7.3627800941467285],
  'Benghazi': [32.096801757799994, 20.2695007324],
  'Benguela': [-12.609000206, 13.4036998749],
  'Benin': [6.316979885101318, 5.5995001792907715],
  'Benson': [51.616401672399995, -1.09582996368],
  'Berbera': [10.389200210571289, 44.94110107421875],
  'Berberati': [4.2215800285339355, 15.786399841308594],
  'Bergamo': [45.673901, 9.70417],
  'Bergen': [60.29339981, 5.218140125],
  'Bergerac': [44.82529830932617, 0.5186110138893127],
  'Berlin': [52.380001, 13.5225],
  'Bern': [46.914100647, 7.497149944309999],
  'Besalampy': [-16.744530296500002, 44.4824838638],
  'Beziers': [43.32350158691406, 3.3538999557495117],
  'Biarritz-bayonne': [43.4683333, -1.5311111],
  'Bielefeld': [51.964722, 8.544444],
  'Biggin Hill': [51.33079910279999, 0.0324999988079],
  'Bilbao': [43.30110168457031, -2.9106099605560303],
  'Billund': [55.7402992249, 9.15178012848],
  'Birmingham': [52.453899383499994, -1.74802994728],
  'Bisha': [19.984399795532227, 42.62089920043945],
  'Bisho': [-32.8970985413, 27.279100418099997],
  'Biskra': [34.793300628699996, 5.73823022842],
  'Bitam': [2.0756399631500244, 11.493200302124023],
  'Blackbushe': [51.32389831542969, -0.8475000262260437],
  'Blackpool': [53.77170181274414, -3.0286099910736084],
  'Blantyre': [-15.679100036621094, 34.9739990234375],
  'Blida': [36.50360107421875, 2.8141698837280273],
  'Bloemfontein': [-29.092699050900002, 26.302400589],
  'Bluefields': [11.991000175476074, -83.77410125732422],
  'Boa Vista': [16.136499404907227, -22.888900756835938],
  'Bobo-dioulasso': [11.160099983215332, -4.33096981048584],
  'Bocas Del Toro': [9.340849876403809, -82.25080108642578],
  'Bodo': [67.26920318603516, 14.365300178527832],
  'Bodrum': [37.140098571777344, 27.669700622558594],
  'Bogota': [4.711, -74.0721],
  'Bologna': [44.5354, 11.2887],
  'Bolzano': [46.460201, 11.3264],
  'Bongao': [5.0333, 119.7667],
  'Bora Bora': [-16.444400787353516, -151.75100708007812],
  'Bordeaux': [44.828300476100004, -0.715556025505],
  'Borkum': [53.59639, 6.709167],
  'Borlange': [60.422000885009766, 15.515199661254883],
  'Boston': [42.3601, -71.0589],
  'Bou Saada': [35.33250045776367, 4.206389904022217],
  'Bouake': [7.738800048828125, -5.073669910430908],
  'Bourgas': [42.56959915161133, 27.515199661254883],
  'Bourges': [47.058101654052734, 2.3702800273895264],
  'Bournemouth': [50.779998779296875, -1.8424999713897705],
  'Braga': [41.5871009827, -8.445139884949999],
  'Braganca': [41.8578, -6.70713],
  'Brandon': [49.91, -99.951897],
  'Brasilia': [-15.8267, -47.9218],
  'Bratislava': [48.17020034790039, 17.21269989013672],
  'Braunschweig': [52.319199, 10.5561],
  'Brazzaville': [-4.251699924468994, 15.253000259399414],
  'Bremen': [53.0475006104, 8.78666973114],
  'Bremerhaven': [53.506943, 8.572778],
  'Brescia': [45.428902, 10.3306],
  'Brest': [48.447898864746094, -4.418540000915527],
  'Bridgetown': [13.0969, -59.6145],
  'Brindisi': [40.6576, 17.947001],
  'Brisbane': [-27.4698, 153.0251],
  'Bristol': [51.382702, -2.71909],
  'Brive': [45.039722, 1.485556],
  'Brize Norton': [51.75, -1.58362],
  'Brno': [49.15129852294922, 16.694400787353516],
  'Bronnoysund': [65.461097717285, 12.217499732971],
  'Broughton Island': [67.5457992554, -64.03140258789999],
  'Brussels': [50.8503, 4.3517],
  'Bucharest': [44.50320053100586, 26.102100372314453],
  'Budapest': [47.42976, 19.261093],
  'Buenos Aires': [-34.6037, -58.3816],
  'Buffalo Narrows': [55.8418998718, -108.417999268],
  'Bujumbura': [-3.3240199089050293, 29.318500518798828],
  'Bukavu/kavumu': [-2.3089799880981445, 28.808799743652344],
  'Bulawayo': [-20.017401, 28.617901],
  'Bullocks Harbour': [25.7383, -77.840103],
  'Bunia': [1.5657199621200562, 30.220800399780273],
  'Burbank': [34.1808, -118.309],
  'Burg Feuerstein': [49.794166564941, 11.133610725403],
  'Burwash': [61.37110137939453, -139.04100036621094],
  'Bushehr': [28.9447994232, 50.8345985413],
  'Buta Zega': [2.818350076675415, 24.793699264526367],
  'Butuan City': [8.9492, 125.5436],
  'Cabinda': [-5.59699010848999, 12.188400268554688],
  'Cabo Rojo': [17.929000854492188, -71.6447982788086],
  'Caen': [49.173301696777344, -0.44999998807907104],
  'Cagayan de Oro': [8.4822, 124.6472],
  'Cagliari': [39.251499, 9.05428],
  'Cahors': [44.35139846801758, 1.4752800464630127],
  'Cairo': [30.0444, 31.2357],
  'Calabar': [4.976019859313965, 8.347200393676758],
  'Calais': [50.962100982666016, 1.954759955406189],
  'Calbayog City': [12.0664, 124.6036],
  'Calgary': [51.0447, -114.0719],
  'Calvi': [42.5244444, 8.7930556],
  'Camaguey': [21.420299530029297, -77.84750366210938],
  'Cambridge': [52.205002, 0.175],
  'Cambridge Bay': [69.1081008911, -105.138000488],
  'Campbell River': [49.950801849365234, -125.27100372314453],
  'Campeche': [19.816799163800003, -90.5002975464],
  'Cancun': [21.1619, -86.8515],
  'Cannes': [43.542, 6.95348],
  'Cap Haitien': [19.733, -72.194702],
  'Cap Skiring': [12.39533, -16.748],
  'Cape Dorset': [64.2300033569, -76.5267028809],
  'Cape Town': [-33.9249, 18.4241],
  'Caransebes': [45.41999816894531, 22.253299713134766],
  'Carcassonne': [43.215999603271484, 2.3063199520111084],
  'Cardiff': [51.39670181274414, -3.343329906463623],
  'Carlisle': [54.9375, -2.8091700077056885],
  'Casablanca': [33.36750030517578, -7.589970111846924],
  'Cascais': [38.724998, -9.35523],
  'Castlegar': [49.2963981628, -117.632003784],
  'Castres': [43.55630111694336, 2.289180040359497],
  'Castries': [13.9957, -61.0061],
  'Catania': [37.466801, 15.0664],
  'Catarman': [12.4982, 124.6356],
  'Cauayan City': [16.9275, 121.7703],
  'Cayes': [18.271099090576172, -73.78829956054688],
  'Cayman Brac': [19.687000274658203, -79.88279724121094],
  'Cayo Largo del Sur': [21.6165008545, -81.5459976196],
  'Cebu': [10.3157, 123.8854],
  'Celle': [52.59120178222656, 10.022100448608398],
  'Chacarita': [9.98141002655, -84.7726974487],
  'Chalons': [48.7733333333, 4.206111111],
  'Chambery': [45.638099670410156, 5.880229949951172],
  'Changuinola': [9.458962, -82.515062],
  'Chania': [35.531700134277344, 24.149700164794922],
  'Chapleau': [47.81999969482422, -83.3467025756836],
  'Charleroi': [50.459202, 4.45382],
  'Charleville': [49.78390121459961, 4.647079944610596],
  'Charlo': [47.990799, -66.330299],
  'Charlotte': [35.2271, -80.8431],
  'Charlottetown': [46.290000915527344, -63.12110137939453],
  'Chateauroux': [46.860278, 1.721111],
  'Chatham': [47.007801, -65.449203],
  'Chatham Island': [-43.810001373291016, -176.45700073242188],
  'Chennai': [13.0827, 80.2707],
  'Cherbourg': [49.65010070800781, -1.4702800512313843],
  'Chetumal': [18.50469970703125, -88.32679748535156],
  'Chicago': [41.8781, -87.6298],
  'Chihuahua': [28.702899932900003, -105.964996338],
  'Chilliwack': [49.1528015137, -121.939002991],
  'Chios': [38.34320068359375, 26.140600204467773],
  'Chiredzi': [-21.008101, 31.5786],
  'Chisinau': [46.92770004272461, 28.930999755859375],
  'Cholet': [47.08209991455078, -0.8770639896392822],
  'Christchurch': [-43.5321, 172.6362],
  'Chub Cay': [25.41710090637207, -77.88089752197266],
  'Churchill': [58.739200592041016, -94.06500244140625],
  'Ciego De Avila': [22.027099609375, -78.78959655761719],
  'Cienfuegos': [22.149999618530273, -80.41419982910156],
  'Cincinnati': [39.1031, -84.512],
  'Ciudad Acuna': [29.332899, -101.098998],
  'Ciudad Del Carmen': [18.65369987487793, -91.79900360107422],
  'Ciudad Juarez': [31.63610076904297, -106.42900085449219],
  'Ciudad Obregon': [27.39259910583496, -109.83300018310547],
  'Ciudad Victoria': [23.7033004761, -98.9564971924],
  'Clarence Bain': [24.287700653076172, -77.68460083007812],
  'Clermont-Ferrand': [45.7867012024, 3.1691699028],
  'Cluj-napoca': [46.78519821166992, 23.686199188232422],
  'Clyde River': [70.4860992432, -68.5167007446],
  'Coban': [15.468999862670898, -90.40670013427734],
  'Cockburn Town': [24.06329917907715, -74.52400207519531],
  'Cognac': [45.65829849243164, -0.3174999952316284],
  'Cold Lake': [54.404998779296875, -110.27899932861328],
  'Colima': [19.277, -103.577002],
  'Colmar': [48.109901428222656, 7.359010219573975],
  'Cologne': [50.8658981323, 7.1427397728],
  'Colorado Springs': [38.8339, -104.8214],
  'Columbus': [39.9612, -82.9988],
  'Comox': [49.71080017089844, -124.88700103759766],
  'Coningsby': [53.0929985046, -0.166014000773],
  'Connaught': [53.910301208496094, -8.818490028381348],
  'Constanta': [44.36220169067383, 28.488300323486328],
  'Constantine': [36.2760009765625, 6.620389938354492],
  'Copenhagen': [55.6761, 12.5683],
  'Coppermine': [67.816704, -115.143997],
  'Coral Harbour': [64.1932983398, -83.3593978882],
  'Cordoba': [37.84199905395508, -4.848879814147949],
  'Cork': [51.84130096435547, -8.491109848022461],
  'Coron': [12, 120.2],
  'Coronation': [52.0750007629, -111.444999695],
  'Cotabato City': [7.2047, 124.231],
  'Coto 47': [8.60155963897705, -82.96859741210938],
  'Cotonou': [6.357230186462402, 2.384350061416626],
  'Cottbus': [51.889442, 14.531944],
  'Coventry': [52.3697013855, -1.4797199964499999],
  'Cozumel': [20.52239990234375, -86.92559814453125],
  'Craiova': [44.31809997558594, 23.888599395751953],
  'Cranbrook': [49.610801696777, -115.78199768066],
  'Creil': [49.253501892089844, 2.5191400051116943],
  'Crotone': [38.9972, 17.0802],
  'Cuernavaca': [18.834800720214844, -99.26129913330078],
  'Culiacan': [24.7644996643, -107.474998474],
  'Cunagua': [22.461000442499998, -78.32839965820001],
  'Cuneo': [44.547001, 7.62322],
  'Curacao': [12.1696, -68.99],
  'Dakar': [14.739700317382812, -17.49020004272461],
  'Dalaman': [36.7131004333, 28.7924995422],
  'Dallas': [32.7767, -96.797],
  'Daloa': [6.792809963226318, -6.473189830780029],
  'Damazin': [11.7859, 34.3367],
  'Dammam': [26.471200942993164, 49.79790115356445],
  'Dar Es Salaam': [-6.87811, 39.202599],
  'Dauphin': [51.100799560546875, -100.052001953125],
  'Davao City': [7.0731, 125.6128],
  'David': [8.390999794006348, -82.43499755859375],
  'Dawson': [64.04309844970703, -139.1280059814453],
  'Dawson Creek': [55.7422981262207, -120.18299865722656],
  'De Kooy': [52.92340087890625, 4.780620098114014],
  'Dead Man\'s Cay': [23.1790008545, -75.09359741210001],
  'Dease Lake': [58.4221992493, -130.031997681],
  'Deauville': [49.3652992249, 0.154305994511],
  'Debrecen': [47.48889923095703, 21.615299224853516],
  'Decimomannu': [39.354198, 8.97248],
  'Deer Lake': [49.21080017089844, -57.39139938354492],
  'Del Bajio': [20.9935, -101.481003],
  'Delhi': [28.7041, 77.1025],
  'Denizli': [37.7855987549, 29.7012996674],
  'Denver': [39.7392, -104.9903],
  'Desroches': [-5.6967, 53.6558],
  'Detroit': [42.3314, -83.0458],
  'Dezful': [32.434399, 48.397598],
  'Dhahran': [26.265399932900003, 50.152000427199994],
  'Diego Garcia Island': [-7.31327, 72.411102],
  'Dijon': [47.268902, 5.09],
  'Dinard': [48.58769989013672, -2.0799601078033447],
  'Dipolog City': [8.5833, 123.3417],
  'Dire Dawa': [9.624699592590332, 41.85419845581055],
  'Diyabakir': [37.893901825, 40.201000213600004],
  'Djanet': [24.292801, 9.45244],
  'Djerba': [33.875, 10.775500297546387],
  'Dodoma': [-6.170440196990967, 35.752601623535156],
  'Dole': [47.042686, 5.435063],
  'Donaueschingen': [47.97333145139999, 8.52222156525],
  'Dongola': [19.153900146499996, 30.430099487299998],
  'Dortmund': [51.51829910279999, 7.61223983765],
  'Douala': [4.0060801506, 9.719479560849999],
  'Dresden': [51.1328010559082, 13.767200469970703],
  'Dryden': [49.831699, -92.744202],
  'Dubai': [25.2048, 55.2708],
  'Dublin': [53.3498, -6.2603],
  'Dubrovnik': [42.5614013671875, 18.268199920654297],
  'Duesseldorf': [51.289501, 6.76678],
  'Dumaguete City': [9.3069, 123.3054],
  'Duncan Town': [22.181800842285156, -75.72949981689453],
  'Dundee': [56.45249938964844, -3.025830030441284],
  'Dunedin': [-45.9281005859375, 170.197998046875],
  'Durango': [24.1242008209, -104.527999878],
  'Durban': [-29.6144444444, 31.1197222222],
  'Dzaoudzi': [-12.804699897766113, 45.28110122680664],
  'Earlton': [47.697400654599996, -79.8473453522],
  'East London': [-33.0355987549, 27.825899124099998],
  'East Midlands': [52.8311004639, -1.32806003094],
  'Ech-cheliff': [36.2126998901, 1.33176994324],
  'Edinburgh': [55.95000076293945, -3.372499942779541],
  'Edmonton': [53.309700012200004, -113.580001831],
  'Edson': [53.578899383499994, -116.464996338],
  'Egelsbach': [49.959999, 8.645833],
  'Egilsstadir': [65.2833023071289, -14.401399612426758],
  'Eindhoven': [51.4500999451, 5.37452983856],
  'Eisenach': [50.991604, 10.47973],
  'El Borma': [31.704299926757812, 9.254619598388672],
  'El Fasher': [13.614899635314941, 25.324600219726562],
  'El Golea': [30.571300506591797, 2.8595900535583496],
  'El Gorah': [31.068559, 34.129629],
  'El Obeid': [13.153200149536133, 30.23270034790039],
  'El-baha': [20.2961006165, 41.6343002319],
  'El-tor': [28.208999633789062, 33.64550018310547],
  'Elat': [29.56130027770996, 34.96009826660156],
  'Elazig': [38.6068992615, 39.2914009094],
  'Eldoret': [0.4044579863548279, 35.23889923095703],
  'Emden': [53.391109, 7.2275],
  'Emmen': [47.092444, 8.305184],
  'Enniskillen': [54.39889907836914, -7.651669979095459],
  'Enontekio': [68.362602233887, 23.424299240112],
  'Enschede': [52.275833, 6.889167],
  'Ensenada': [31.7953, -116.602997],
  'Entebbe': [0.042386, 32.443501],
  'Enugu': [6.474269866943359, 7.561960220336914],
  'Epinal': [48.325001, 6.06998],
  'Er-rachidia': [31.9475002289, -4.39833021164],
  'Erfurt': [50.979801177978516, 10.958100318908691],
  'Erzincan': [39.7102012634, 39.527000427199994],
  'Erzurum': [39.9565010071, 41.17020034789999],
  'Esbjerg': [55.525902, 8.5534],
  'Eskilstuna': [59.35110092163086, 16.70840072631836],
  'Eskimo Point': [61.0942001343, -94.07080078119999],
  'Eskisehir': [39.7840995789, 30.582099914599997],
  'Essen': [51.40230178833008, 6.9373297691345215],
  'Estevan': [49.2103004456, -102.966003418],
  'Eureka': [79.9946975708, -85.814201355],
  'Evreux': [49.02870178222656, 1.2198599576950073],
  'Exeter': [50.73440170288086, -3.4138898849487305],
  'Eyn-yahav': [30.621700286865234, 35.20330047607422],
  'Fagernes': [61.015598297119, 9.2880601882935],
  'Fairford': [51.6822013855, -1.7900300025900002],
  'Fakarava': [-16.054100036621094, -145.65699768066406],
  'Faleolo': [-13.829999923706055, -172.00799560546875],
  'Fangatau': [-15.819899559020996, -140.88699340820312],
  'Farafangana': [-22.805299758911133, 47.82059860229492],
  'Faranah': [10.0354995728, -10.7698001862],
  'Farnborough': [51.2757987976, -0.776332974434],
  'Faro': [62.20750045776367, -133.37600708007812],
  'Farsund': [58.0994987487793, 6.626049995422363],
  'Faya-largeau': [17.91710090637207, 19.111099243164062],
  'Fes': [33.9272994995, -4.977960109709999],
  'Fianarantsoa': [-21.441600799560547, 47.111698150634766],
  'Ficksburg': [-28.82309913635254, 27.908899307250977],
  'Figari': [41.5005989074707, 9.097780227661133],
  'Fira': [10.350600242615, -13.569199562073],
  'Flensburg': [54.77333450317383, 9.378889083862305],
  'Flin Flon': [54.6781005859375, -101.68199920654297],
  'Florence': [43.810001, 11.2051],
  'Flores': [39.455299377441406, -31.131399154663086],
  'Floro': [61.583599090576, 5.0247201919556],
  'Foggia': [41.432899, 15.535],
  'Forestville': [48.74610137939453, -69.09719848632812],
  'Forli': [44.194801, 12.0701],
  'Fort Chipewyan': [58.7672004699707, -111.11699676513672],
  'Fort Lauderdale': [26.1224, -80.1373],
  'Fort Mcmurray': [56.653301239, -111.222000122],
  'Fort Mcpherson': [67.40750122070312, -134.86099243164062],
  'Fort Nelson': [58.8363990784, -122.597000122],
  'Fort Resolution': [61.1808013916, -113.690002441],
  'Fort Saint John': [56.23809814453125, -120.73999786376953],
  'Fort Simpson': [61.76020050048828, -121.23699951171875],
  'Fort Smith': [60.020301818847656, -111.96199798583984],
  'Foumban': [5.636919975280762, 10.750800132751465],
  'Franceville': [-1.6561599969863892, 13.437999725341797],
  'Francistown': [-21.15959930419922, 27.47450065612793],
  'Frankfurt': [50.1109, 8.6821],
  'Fredericton': [45.868900299072266, -66.53720092773438],
  'Freeport': [26.5587005615, -78.695602417],
  'Freetown': [8.61644, -13.1955],
  'Friedrichshafen': [47.671298980699994, 9.51148986816],
  'Fritzlar': [51.1146, 9.286],
  'Fuerstenfeldbruck': [48.205555, 11.266944],
  'Fuerteventura': [28.452699661254883, -13.863800048828125],
  'Gaberone': [-24.555201, 25.9182],
  'Gabes': [33.87689971923828, 10.103300094604492],
  'Gachsaran': [30.337600708, 50.827999115],
  'Gafsa': [34.422000885009766, 8.822500228881836],
  'Gallivare': [67.13240051269531, 20.814599990844727],
  'Galway': [53.300201416015625, -8.941590309143066],
  'Gambella': [8.12876033782959, 34.5630989074707],
  'Gander': [48.9369010925293, -54.56809997558594],
  'Gao': [16.24839973449707, -0.005456000100821257],
  'Garoua': [9.33588981628418, 13.370100021362305],
  'Gaspe': [48.7752990723, -64.4785995483],
  'Gassim': [26.302799224853516, 43.77439880371094],
  'Gatineau': [45.521701812699995, -75.5635986328],
  'Gavle': [60.593299865722656, 16.951400756835938],
  'Gaziantep': [36.9472007751, 37.4786987305],
  'Gbadolite': [4.253210067749023, 20.975299835205078],
  'Gdansk': [54.377601623535156, 18.46619987487793],
  'Geilenkirchen': [50.9608, 6.04242],
  'Geilo': [60.417301177978516, 8.518349647521973],
  'Gemena': [3.2353699207299997, 19.771299362199997],
  'General Santos City': [6.1128, 125.1717],
  'Geneva': [46.23809814453125, 6.108950138092041],
  'Genoa': [44.4133, 8.8375],
  'George': [-34.0056, 22.378902],
  'Georgetown': [19.292800903299998, -81.3576965332],
  'Geraldton': [49.77830123901367, -86.93939971923828],
  'Gerona': [41.901000977, 2.7605500221],
  'Ghadames': [30.15169906616211, 9.715310096740723],
  'Ghardaia': [32.38410186767578, 3.794110059738159],
  'Ghat': [25.1455993652, 10.142600059500001],
  'Ghriss': [35.207698822021484, 0.14714199304580688],
  'Gibraltar': [36.1511993408, -5.3496599197400005],
  'Giebelstadt': [49.648101806599996, 9.966489791870002],
  'Gilze-rijen': [51.56740188598633, 4.931829929351807],
  'Gisborne': [-38.663299560546875, 177.97799682617188],
  'Gisenyi': [-1.6771999597549438, 29.258899688720703],
  'Gizan': [16.901100158691406, 42.58580017089844],
  'Gjoa Haven': [68.635597229, -95.84970092770001],
  'Glasgow': [55.8718986511, -4.43306016922],
  'Glentanner': [-43.906700134277344, 170.1280059814453],
  'Godthaab': [64.19090271, -51.6781005859],
  'Golfito': [8.654009819030762, -83.18219757080078],
  'Golouchestershire': [51.89419937133789, -2.167220115661621],
  'Goma': [-1.6708099842071533, 29.238500595092773],
  'Gondar': [12.51990032196045, 37.433998107910156],
  'Goose Bay': [53.3191986084, -60.4258003235],
  'Gore Bay': [45.88529968261719, -82.56780242919922],
  'Gorna Orechovica': [43.15140151977539, 25.712900161743164],
  'Goroka': [-6.081689834590001, 145.391998291],
  'Gothenborg': [57.662799835205, 12.279800415039],
  'Governor\'s Harbor': [25.2847003937, -76.3310012817],
  'Graciosa Island': [39.092201232910156, -28.029800415039062],
  'Gran Canaria': [27.931900024414062, -15.38659954071045],
  'Granada': [37.18870162963867, -3.777359962463379],
  'Grande Prairie': [55.1796989441, -118.885002136],
  'Granville': [48.88309860229492, -1.564170002937317],
  'Graz': [46.9911003112793, 15.439599990844727],
  'Great Exuma': [23.5625991821, -75.8779983521],
  'Greenwood': [44.98440170288086, -64.91690063476562],
  'Grenchen': [47.181599, 7.41719],
  'Grenoble': [45.36289978027344, 5.329370021820068],
  'Groningen': [53.1197013855, 6.57944011688],
  'Grosseto': [42.759701, 11.0719],
  'Grottaglie': [40.517502, 17.4032],
  'Guadalajara': [20.6597, -103.3496],
  'Guanaja': [16.4454, -85.906601],
  'Guangzhou': [23.1291, 113.2644],
  'Guantanamo': [19.906499862671, -75.207099914551],
  'Guapiles': [10.2172002792, -83.79699707030001],
  'Guatemala City': [14.6349, -90.5069],
  'Guaymas': [27.9689998626709, -110.92500305175781],
  'Guernsey': [49.435001373291016, -2.6019699573516846],
  'Guetersloh': [51.922798, 8.30633],
  'Guriat': [31.412413, 37.278898],
  'Gwert': [-19.436399459838867, 29.861900329589844],
  'Hafr Al-batin': [28.335199, 46.125099],
  'Hahn': [49.9487, 7.26389],
  'Haifa': [32.80939865112305, 35.04309844970703],
  'Hail': [27.437901, 41.686298],
  'Halifax': [44.8807983398, -63.5085983276],
  'Hall Beach': [68.77610015869999, -81.2425],
  'Halli': [61.856039, 24.786686],
  'Halmstad': [56.69110107421875, 12.820199966430664],
  'Hamburg': [53.630401611328, 9.9882297515869],
  'Hamilton': [43.173599243199995, -79.93499755859999],
  'Hanau': [50.169201, 8.96159],
  'Hannover': [52.461101532, 9.685079574580001],
  'Hao Island': [-18.074800491333008, -140.9459991455078],
  'Harare': [-17.931801, 31.0928],
  'Hargeisa': [9.518170356750488, 44.08879852294922],
  'Harrismith': [-28.23509979248047, 29.106199264526367],
  'Harstad/Narvik': [68.491302490234, 16.678100585938],
  'Hassi Messaoud': [31.673000335699996, 6.140439987180001],
  'Hasvik': [70.486701965332, 22.139699935913],
  'Haugesund': [59.34529876709, 5.2083601951599],
  'Havana': [22.989200592041016, -82.40910339355469],
  'Haverfordwest': [51.833099365234375, -4.9611101150512695],
  'Hawarden': [53.1781005859375, -2.9777801036834717],
  'Hay River': [60.8396987915, -115.782997131],
  'Helsinki': [60.1699, 24.9384],
  'Heraklion': [35.3396987915, 25.180299758900002],
  'Herat': [34.209999084472656, 62.22829818725586],
  'Hermosillo': [29.095899581900003, -111.047996521],
  'Hierro': [27.814800262451172, -17.887100219726562],
  'High Level': [58.62139892578125, -117.16500091552734],
  'Hoedspruit': [-24.368600845299998, 31.0487003326],
  'Hof': [50.288612365722656, 11.856389045715332],
  'Hofn': [64.295601, -15.2272],
  'Hokitika': [-42.713600158691406, 170.98500061035156],
  'Holguin': [20.785600662231445, -76.31510162353516],
  'Holman Island': [70.76280212402344, -117.80599975585938],
  'Hon': [29.11009979248047, 15.96560001373291],
  'Hong Kong': [22.3193, 114.1694],
  'Honington': [52.34260177612305, 0.7729390263557434],
  'Honolulu': [21.3099, -157.8581],
  'Horta': [38.519901275634766, -28.715900421142578],
  'Houston': [29.7604, -95.3698],
  'Howard': [8.91479, -79.599602],
  'Huahine Island': [-16.68720054626465, -151.02200317382812],
  'Huambo': [-12.808899879455566, 15.760499954223633],
  'Huatulco': [15.7753, -96.262604],
  'Hudiksvall': [61.7681007385, 17.0806999207],
  'Hudson Bay': [52.8166999817, -102.310997009],
  'Hultsfred': [57.525799, 15.8233],
  'Humberside': [53.57440185546875, -0.350832998752594],
  'Hurghada': [27.178300857543945, 33.799400329589844],
  'Husavik': [65.952301, -17.426001],
  'Hwange National Park': [-18.629899978637695, 27.020999908447266],
  'Hyderabad': [17.385, 78.4867],
  'Hyeres': [43.0973014832, 6.14602994919],
  'Hyvinkaa': [60.6543998718, 24.8810997009],
  'Iasi': [47.17850112915039, 27.6205997467041],
  'Ibadan': [7.362460136413574, 3.97832989692688],
  'Ibiza': [38.872898101800004, 1.3731199502899998],
  'Iles De La Madeleine': [47.42470169067383, -61.778099060058594],
  'Illizi': [26.7234992981, 8.62265014648],
  'Iloilo City': [10.6969, 122.5644],
  'Ilorin': [8.440210342407227, 4.493919849395752],
  'In Salah': [27.250999450699997, 2.51202011108],
  'Indianapolis': [39.7684, -86.1581],
  'Ingolstadt': [48.7156982421875, 11.534000396728516],
  'Inhambane': [-23.876399993896484, 35.40850067138672],
  'Innsbruck': [47.260201, 11.344],
  'Inuvik': [68.30419921880001, -133.483001709],
  'Invercargill': [-46.41239929199219, 168.31300354003906],
  'Inverness': [57.54249954223633, -4.047500133514404],
  'Ioannina': [39.6963996887207, 20.822500228881836],
  'Iqaluit': [63.756402, -68.555801],
  'Iringa': [-7.668630123138428, 35.75210189819336],
  'Isafjordur': [66.05809783935547, -23.135299682617188],
  'Isiro': [2.8276100158691406, 27.588300704956055],
  'Isla Mujeres': [21.2450008392334, -86.73999786376953],
  'Islay': [55.68190002441406, -6.256669998168945],
  'Isle Of Man': [54.08330154418945, -4.623889923095703],
  'Istanbul': [41.0082, 28.9784],
  'Ivalo': [68.607299804688, 27.405300140381],
  'Izmir': [38.2924003601, 27.156999588],
  'Iztepec': [16.449301, -95.093697],
  'Jacmel': [18.241100311279297, -72.51850128173828],
  'Jakarta': [-6.2088, 106.8456],
  'Jalalabad': [34.39979934692383, 70.49859619140625],
  'Jeddah': [21.6796, 39.156502],
  'Jerez': [36.744598388671875, -6.060110092163086],
  'Jersey': [49.20790100097656, -2.195509910583496],
  'Jijel': [36.7951011658, 5.87361001968],
  'Jimma': [7.66609001159668, 36.81660079956055],
  'Joenkoeping': [57.757598876953125, 14.068699836730957],
  'Joensuu': [62.662899017334, 29.607500076294],
  'Johannesburg': [-26.2041, 28.0473],
  'Jos': [9.639829635620117, 8.869050025939941],
  'Juba': [4.87201023102, 31.6011009216],
  'Jubail': [27.038999557495117, 49.40510177612305],
  'Jwaneng': [-24.6023006439209, 24.69099998474121],
  'Jyvaskyla': [62.399501800537, 25.678300857544],
  'Kabul': [34.565899, 69.212303],
  'Kadugli': [11.137999534600002, 29.7010993958],
  'Kaduna': [10.696000099182129, 7.320109844207764],
  'Kaedi': [16.159500122070312, -13.507599830627441],
  'Kaitaia': [-35.06999969482422, 173.28500366210938],
  'Kajaani': [64.285499572754, 27.692399978638],
  'Kakamega': [0.271342009306, 34.7873001099],
  'Kalamata': [37.06829833984375, 22.02549934387207],
  'Kalemie': [-5.8755598068237305, 29.25],
  'Kalibo': [11.705, 122.3679],
  'Kalkmar': [56.68550109863281, 16.287599563598633],
  'Kamembe': [-2.462239980697632, 28.907899856567383],
  'Kamina Base': [-8.642020225524902, 25.252899169921875],
  'Kamloops': [50.7022018433, -120.444000244],
  'Kananga': [-5.90005016327, 22.4692001343],
  'Kandahar': [31.505800247192383, 65.8478012084961],
  'Kano': [12.0476, 8.52462],
  'Kansas City': [39.0997, -94.5786],
  'Kaolack': [14.146900177001953, -16.051300048828125],
  'Kapuskasing': [49.41389846801758, -82.46749877929688],
  'Kardla': [58.99079895019531, 22.830699920654297],
  'Kariba': [-16.519800186157227, 28.885000228881836],
  'Karlovy Vary': [50.202999114990234, 12.914999961853027],
  'Karlskoga': [59.34590148925781, 14.49590015411377],
  'Karonga': [-9.953570365905762, 33.893001556396484],
  'Karpathos': [35.4213981628418, 27.145999908447266],
  'Karup': [56.29750061035156, 9.124629974365234],
  'Kasane': [-17.83289909362793, 25.162399291992188],
  'Kasompe': [-12.572799682617, 27.893899917603],
  'Kasos': [35.4213981628, 26.909999847399998],
  'Kassala': [15.387499809265137, 36.328800201416016],
  'Kassel': [51.417273, 9.384967],
  'Kastoria': [40.4463005066, 21.2821998596],
  'Kasungu': [-13.014599800109863, 33.46860122680664],
  'Katowice': [50.4743, 19.08],
  'Kauai': [22.0964, -159.5261],
  'Kauhajoki': [62.4625015259, 22.3931007385],
  'Kauhava': [63.127102, 23.051399],
  'Kaukura Atoll': [-15.663299560546875, -146.88499450683594],
  'Kavala': [40.913299560546875, 24.619199752807617],
  'Kayes': [14.481200218200684, -11.404399871826172],
  'Kayseri': [38.770401001, 35.4953994751],
  'Kedougou': [12.57229995727539, -12.22029972076416],
  'Keffallinia': [38.12009811401367, 20.500499725341797],
  'Keflavik': [63.985000610352, -22.605600357056],
  'Kelowna': [49.9561004639, -119.377998352],
  'Kemi': [65.778701782227, 24.582099914551],
  'Kenora': [49.788299560546875, -94.36309814453125],
  'Kentira': [34.29890060424805, -6.595880031585693],
  'Kerikeri': [-35.26279830932617, 173.91200256347656],
  'Kerkyra/corfu': [39.601898193359375, 19.911699295043945],
  'Kerry': [52.18090057373047, -9.52377986907959],
  'Khark Island': [29.260299682617188, 50.32389831542969],
  'Khartoum': [15.589500427246094, 32.553199768066406],
  'Kiel': [54.37944412231445, 10.145277976989746],
  'Kiffa': [16.59000015258789, -11.406200408935547],
  'Kigali': [-1.96863, 30.1395],
  'Kikwit': [-5.035769939422607, 18.785600662231445],
  'Kilimanjaro': [-3.42940998077, 37.0745010376],
  'Kimberley': [-28.802799224900003, 24.7651996613],
  'Kindersley': [51.5175018311, -109.180999756],
  'Kindu': [-2.91917991638, 25.915399551399997],
  'King Khalid Mil.city': [27.9009, 45.528198],
  'Kingston': [18.0179, -76.8099],
  'Kingstown': [13.15, -61.2167],
  'Kinshasa': [-4.38575, 15.4446],
  'Kirkenes': [69.725799560547, 29.891300201416],
  'Kirkwall': [58.957801818847656, -2.9049999713897705],
  'Kiruna': [67.821998596191, 20.336799621582],
  'Kisangani': [0.481638997793, 25.3379993439],
  'Kish Island': [26.5261993408, 53.980201721200004],
  'Kismayu': [-0.3773530125617981, 42.45920181274414],
  'Kisumu': [-0.0861390009522438, 34.72890090942383],
  'Kitale': [0.9719889760017395, 34.95859909057617],
  'Kitee': [62.1661, 30.073601],
  'Kithira': [36.2742996216, 23.0170001984],
  'Kittila': [67.700996398926, 24.846799850464],
  'Kitzingen': [49.743099, 10.2006],
  'Kleinsee': [-29.6884002686, 17.093999862700002],
  'Klerksdorp': [-26.8710994720459, 26.718000411987305],
  'Kolkata': [22.5726, 88.3639],
  'Kolwezi': [-10.765899658203125, 25.505699157714844],
  'Kona': [19.64, -155.9969],
  'Kone': [-21.05430030822754, 164.83700561523438],
  'Konya': [37.979, 32.561901],
  'Korhogo': [9.38718032837, -5.55666017532],
  'Kortrijk-vevelgem': [50.817199707, 3.20472002029],
  'Kos': [36.79330062866211, 27.091699600219727],
  'Kosice': [48.66310119628906, 21.241100311279297],
  'Kotakoli': [4.157639980316162, 21.65089988708496],
  'Koumac': [-20.546300888061523, 164.25599670410156],
  'Kozani': [40.28609848022461, 21.84079933166504],
  'Krakow': [50.077702, 19.7848],
  'Kramfors': [63.04859924316406, 17.76889991760254],
  'Kristiansand': [58.204201, 8.08537],
  'Kristianstad': [55.92169952392578, 14.08549976348877],
  'Kristiansund': [63.111801147461, 7.824520111084],
  'Kruunupyy': [63.721199035645, 23.143100738525],
  'Kuala Lumpur': [3.139, 101.6869],
  'Kufra': [24.178699493408203, 23.31399917602539],
  'Kuito': [-12.404600143433, 16.947399139404],
  'Kunduz': [36.66510009765625, 68.91079711914062],
  'Kunovice': [49.02939987182617, 17.439699172973633],
  'Kuopio': [63.007099151611, 27.797800064087],
  'Kuressaare': [58.22990036010742, 22.50950050354004],
  'Kuruman': [-27.45669937133789, 23.411399841308594],
  'Kuusamo': [65.987602233887, 29.239400863647],
  'La Baule': [47.289398193359375, -2.3463900089263916],
  'La Ceiba': [15.7425, -86.852997],
  'La Coloma': [22.33609962463379, -83.64189910888672],
  'La Coruna': [43.302101, -8.37726],
  'La Grande Riviere': [53.625301361083984, -77.7042007446289],
  'La Paz': [24.072700500499998, -110.361999512],
  'La Roche-sur-yon': [46.701900482177734, -1.3786300420761108],
  'La Romana': [18.450700759887695, -68.91179656982422],
  'La Ronge': [55.151401519800004, -105.262001038],
  'Laage': [53.9182014465, 12.278300285299999],
  'Labe': [11.326100349426, -12.286800384521],
  'Ladysmith': [-28.5816993713, 29.749700546299998],
  'Laeso': [57.277198791503906, 11.000100135803223],
  'Laghouat': [33.764400482199996, 2.92833995819],
  'Lagos': [6.5244, 3.3792],
  'Lajes (terceira Island)': [38.761799, -27.090799],
  'Lake Manyara': [-3.376310110092163, 35.81829833984375],
  'Lakenheath': [52.409301757799994, 0.56099998951],
  'Lakselv': [70.068801879883, 24.973499298096],
  'Lal-lo': [18.2, 121.4167],
  'Lalibella': [11.975000381469727, 38.97999954223633],
  'Lambarene': [-0.7043889760971069, 10.245699882507324],
  'Lamezia': [38.905399, 16.2423],
  'Lampedusa': [35.497898, 12.6181],
  'Lamu': [-2.252419948577881, 40.91310119628906],
  'Landivisiau': [48.53030014038086, -4.151639938354492],
  'Langebaanweg': [-32.968898773199996, 18.1602993011],
  'Lannion': [48.754398, -3.47166],
  'Laoag City': [18.1978, 120.5957],
  'Lappeenranta': [61.044601, 28.144743],
  'Larissa': [39.650253, 22.4655],
  'Larnaca': [34.875099182128906, 33.624900817871094],
  'Las Tunas': [20.987600326538086, -76.93579864501953],
  'Las Vegas': [36.1699, -115.1398],
  'Lasham': [51.187198638916016, -1.0334999561309814],
  'Latina': [41.5424, 12.909],
  'Laval': [48.03139877319336, -0.7429860234260559],
  'Lavan Island': [26.810300827026367, 53.356300354003906],
  'Lazard Cardenas': [18.0016994476, -102.221000671],
  'Le Castellet': [43.252498626708984, 5.785190105438232],
  'Le Havre': [49.53390121459961, 0.08805599808692932],
  'Le Mans': [47.94860076904297, 0.20166699588298798],
  'Le Puy': [45.0806999206543, 3.762890100479126],
  'Le Tourquet': [50.517398834228516, 1.6205899715423584],
  'Lecce': [40.239201, 18.133301],
  'Leeds': [53.86589813232422, -1.6605700254440308],
  'Leeuwarden': [53.228599548339844, 5.760560035705566],
  'Legazpi City': [13.1391, 123.7436],
  'Leipzig': [51.423889, 12.236389],
  'Lelystad': [52.4603, 5.52722],
  'Leros': [37.184898, 26.800301],
  'Lethbridge': [49.6302986145, -112.800003052],
  'Leuchars': [56.37289810180664, -2.8684399127960205],
  'Liberia': [10.5933, -85.544403],
  'Libreville': [0.458600014448, 9.412280082699999],
  'Lichinga': [-13.274, 35.2663],
  'Lidkoping': [58.4655, 13.1744],
  'Liege': [50.63740158081055, 5.443220138549805],
  'Lifou': [-20.774799346923828, 167.24000549316406],
  'Lille': [50.563332, 3.086886],
  'Lilongwe': [-13.7894001007, 33.78099823],
  'Lima': [-12.0464, -77.0428],
  'Limnos': [39.917098999, 25.236299514799995],
  'Limoges': [45.86280059814453, 1.1794400215148926],
  'Limon': [9.95796012878418, -83.02200317382812],
  'Linkoeping': [58.4062004089, 15.680500030500001],
  'Linton-on-ouse': [54.0489006042, -1.2527500391],
  'Linz': [48.2332, 14.1875],
  'Lisala': [2.17066, 21.496901],
  'Lisbon': [38.7223, -9.1393],
  'Liverpool': [53.33359909057617, -2.849720001220703],
  'Livingstone': [-17.821800231933594, 25.82270050048828],
  'Ljubljana': [46.223701, 14.4576],
  'Lloydminster': [53.309200286865234, -110.072998046875],
  'Lodwar': [3.1219699382781982, 35.608699798583984],
  'Lome': [6.165609836578369, 1.2545100450515747],
  'London': [51.5074, -0.1278],
  'Londonderry': [55.04280090332031, -7.161109924316406],
  'Long Beach': [33.7701, -118.1937],
  'Loreto': [25.989200592041016, -111.3479995727539],
  'Lorient': [47.76060104370117, -3.440000057220459],
  'Los Angeles': [34.0522, -118.2437],
  'Los Cabos': [22.8905, -109.9167],
  'Los Chiles': [11.035300254821777, -84.70610046386719],
  'Los Mochis': [25.6851997375, -109.081001282],
  'Lossiemouth': [57.7052001953125, -3.339169979095459],
  'Luanda': [-8.85837, 13.2312],
  'Lubango': [-14.924699783325195, 13.574999809265137],
  'Lubumashi': [-11.5913000107, 27.5308990479],
  'Luebeck': [53.8054008484, 10.7192001343],
  'Luena': [-11.768099784851074, 19.8976993560791],
  'Lugano': [46.00429916379999, 8.9105796814],
  'Lulea': [65.543800354004, 22.121999740601],
  'Lumbo': [-15.0331001282, 40.671699523899996],
  'Lusaka': [-15.3308000565, 28.4526004791],
  'Luxemburg': [49.6233333, 6.2044444],
  'Luxor': [25.671, 32.7066],
  'Lycksele': [64.54830169677734, 18.71619987487793],
  'Lydd': [50.95610046386719, 0.9391670227050781],
  'Lyneham': [51.5051, -1.99343],
  'Lynn Lake': [56.86389923095703, -101.07599639892578],
  'Lyon': [45.725556, 5.081111],
  'M\'banza-congo': [-6.269899845123291, 14.246999740600586],
  'Maastricht': [50.911701, 5.77014],
  'Madang': [-5.20707988739, 145.789001465],
  'Madinah': [24.5534, 39.705101],
  'Madrid': [40.4168, -3.7038],
  'Magdeburg': [52.073612, 11.626389],
  'Mahajanga': [-15.6668417421, 46.351232528699995],
  'Mahe': [-4.67434, 55.521801],
  'Maiduguri': [11.855299949645996, 13.080900192260742],
  'Maimama': [35.93080139160156, 64.76090240478516],
  'Maio': [15.155900001525879, -23.213699340820312],
  'Makale': [13.467399597167969, 39.53350067138672],
  'Makemo': [-16.583900451660156, -143.6580047607422],
  'Makokou': [0.5792109966278076, 12.890899658203125],
  'Makurdi': [7.70388, 8.61394],
  'Malabo': [3.755270004272461, 8.708720207214355],
  'Malaga': [36.67490005493164, -4.499110221862793],
  'Malakal': [9.55897045135498, 31.65220069885254],
  'Malalane': [-25.4300003052, 31.5767002106],
  'Malanje': [-9.525090217590332, 16.312400817871094],
  'Malatya': [38.435298919699996, 38.0909996033],
  'Malay': [11.9216, 121.9504],
  'Malmoe': [55.536305364, 13.376197814900001],
  'Malta': [35.857498, 14.4775],
  'Mambajao': [9.25, 124.7167],
  'Man': [7.272069931030273, -7.58735990524292],
  'Managua': [12.141500473022461, -86.16819763183594],
  'Manakara': [-22.119699478149414, 48.02170181274414],
  'Mananara': [-16.16390037536621, 49.773799896240234],
  'Mananjary': [-21.201799392700195, 48.358299255371094],
  'Manapouri': [-45.53310012817383, 167.64999389648438],
  'Manchester': [53.35369873046875, -2.2749500274658203],
  'Manihi': [-14.436800003051758, -146.07000732421875],
  'Manila': [14.5995, 120.9842],
  'Maniwaki': [46.2728004456, -75.9906005859],
  'Mannheim': [49.473057, 8.514167],
  'Manston': [51.342201, 1.34611],
  'Manzanillo': [19.144800186199998, -104.558998108],
  'Manzini': [-26.52899932861328, 31.3075008392334],
  'Maputo': [-25.920799, 32.572601],
  'Maradi': [13.5024995803833, 7.1267499923706055],
  'Mare': [-21.481700897216797, 168.03799438476562],
  'Margate': [-30.8574008942, 30.343000412],
  'Marham': [52.648395, 0.550692],
  'Maribo': [54.699299, 11.4401],
  'Maribor': [46.47990036010742, 15.686100006103516],
  'Mariehamn': [60.122200012207, 19.898199081421],
  'Marina Di Campo': [42.7603, 10.2394],
  'Maroantsetra': [-15.436699867248535, 49.68830108642578],
  'Maroua': [10.451399803161621, 14.257399559020996],
  'Marrakech': [31.606899261499997, -8.03629970551],
  'Marsa Brega': [30.37809944152832, 19.576400756835938],
  'Marseille': [43.439271922, 5.22142410278],
  'Marsh Harbor': [26.5114, -77.083503],
  'Masbate City': [12.3649, 123.6177],
  'Maseru': [-29.462299346923828, 27.552499771118164],
  'Masterton': [-40.97330093383789, 175.63400268554688],
  'Masvingo': [-20.055299758911133, 30.859100341796875],
  'Matagami': [49.76169967651367, -77.80280303955078],
  'Mataiva': [-14.8681001663208, -148.7169952392578],
  'Matamoros': [25.7698993683, -97.5252990723],
  'Matthew Town': [20.975000381469727, -73.66690063476562],
  'Maubeuge': [50.31050109863281, 4.033120155334473],
  'Maui': [20.7984, -156.3319],
  'Maun': [-19.97260093688965, 23.431100845336914],
  'Maupiti': [-16.42650032043457, -152.24400329589844],
  'Mayaguana': [22.379499, -73.013494],
  'Mayo': [63.61640167236328, -135.8679962158203],
  'Mazar-i-sharif': [36.70690155029297, 67.20970153808594],
  'Mazatlan': [23.1613998413, -106.26599884],
  'Mbandaka': [0.0226000007242, 18.2887001038],
  'Mbuji-mayi': [-6.121240139010001, 23.569000244099996],
  'Meadow Lake': [54.125301361083984, -108.52300262451172],
  'Mecheria': [33.535900116, -0.242353007197],
  'Medicine Hat': [50.01890182495117, -110.72100067138672],
  'Meknes': [33.87910079956055, -5.515120029449463],
  'Melbourne': [-37.8136, 144.9631],
  'Melilla': [35.279800415, -2.9562599659],
  'Mende': [44.502102, 3.53282],
  'Menongue': [-14.657600402832031, 17.71980094909668],
  'Menorca': [39.86259841918945, 4.218649864196777],
  'Merida': [20.937000274699997, -89.657699585],
  'Mersa-matruh': [31.3253993988, 27.221700668300002],
  'Merville': [50.61840057373047, 2.642240047454834],
  'Merzifon': [40.829399, 35.521999],
  'Mesa': [33.4152, -111.8315],
  'Metz': [48.9821014404, 6.25131988525],
  'Metzada': [31.32819938659668, 35.38859939575195],
  'Mexicali': [32.6306, -115.241997],
  'Mexico City': [19.4326, -99.1332],
  'Mfuwe': [-13.258899688720703, 31.936599731445312],
  'Miami': [25.7617, -80.1918],
  'Miandrivazo': [-19.56279945373535, 45.450801849365234],
  'Mikkeli': [61.6866, 27.201799],
  'Milan': [45.4642, 9.19],
  'Milano': [45.6306, 8.72811],
  'Mildenhall': [52.361900329589844, 0.48640599846839905],
  'Minatitlan': [18.1033992767, -94.58070373540001],
  'Minna': [9.652170181274414, 6.462259769439697],
  'Minneapolis': [44.9778, -93.265],
  'Miquelon': [47.095500946, -56.3802986145],
  'Mkuze': [-27.626100540161133, 32.0443000793457],
  'Moa': [20.653900146484375, -74.92220306396484],
  'Mocimboa Da Praia': [-11.361800193786621, 40.35490036010742],
  'Moenchengladbach': [51.230278, 6.504444],
  'Moheli': [-12.298100471496582, 43.76639938354492],
  'Molde': [62.744701385498, 7.2624998092651],
  'Mombasa': [-4.034830093383789, 39.594200134277344],
  'Monastir': [35.75809860229492, 10.75469970703125],
  'Monclova': [26.9557, -101.470001],
  'Moncton': [46.11220169067383, -64.67859649658203],
  'Mongu': [-15.254500389099121, 23.16230010986328],
  'Monrovia': [6.289060115814209, -10.758700370788574],
  'Mont Joli': [48.60860061645508, -68.20809936523438],
  'Montauban': [44.025699615478516, 1.3780399560928345],
  'Monte Real': [39.828335, -8.8875],
  'Montego Bay': [18.4762, -77.8939],
  'Monterrey': [25.865601, -100.237],
  'Montlucon-gueret': [46.222599029541016, 2.363960027694702],
  'Montpellier': [43.57619857788086, 3.96301007270813],
  'Montreal': [45.5017, -73.5673],
  'Moorea': [-17.49, -149.761993],
  'Moose Jaw': [50.330299377441406, -105.55899810791016],
  'Moosonee': [51.291099548339844, -80.60780334472656],
  'Mopti': [14.5128002167, -4.0795598030099995],
  'Mora': [60.957901, 14.5114],
  'Morelia': [19.849899292, -101.025001526],
  'Morlaix': [48.6031990051, -3.81577992439],
  'Morombe': [-21.7539005279541, 43.3754997253418],
  'Morondava': [-20.284700393676758, 44.31760025024414],
  'Moroni': [-11.5337, 43.2719],
  'Mosjoen': [65.783996582031, 13.214900016785],
  'Mostar': [43.282901763916016, 17.84589958190918],
  'Moundou': [8.624409675598145, 16.071399688720703],
  'Mount Cook': [-43.76499938964844, 170.13299560546875],
  'Mount Hagen': [-5.826789855957031, 144.29600524902344],
  'Mount Pleasant': [-51.82279968261719, -58.447200775146484],
  'Mtwara': [-10.339099884033203, 40.181800842285156],
  'Muanda': [-5.9308600425720215, 12.351799964904785],
  'Mueda': [-11.672900199890137, 39.5630989074707],
  'Mulhouse': [47.59, 7.5291667],
  'Mumbai': [19.076, 72.8777],
  'Munich': [48.1351, 11.582],
  'Munster': [52.134601593, 7.68483018875],
  'Murcia': [37.775001525878906, -0.8123890161514282],
  'Muskoka': [44.974700927734375, -79.30329895019531],
  'Mutare': [-18.997499465942, 32.627201080322],
  'Mwanza': [-2.4444899559020996, 32.932701110839844],
  'Mykonos': [37.43510055541992, 25.348100662231445],
  'Mytilini': [39.0567016602, 26.5983009338],
  'Mzuzu': [-11.444700241088867, 34.01179885864258],
  'N\'djamena': [12.1337, 15.034],
  'N\'gaoundere': [7.3570098876953125, 13.559200286865234],
  'Nacala': [-14.488200187683105, 40.71220016479492],
  'Nadzab': [-6.569803, 146.725977],
  'Naga City': [13.6218, 123.1948],
  'Nairobi': [-1.2864, 36.8172],
  'Nampula': [-15.105600357055664, 39.28179931640625],
  'Nanaimo': [49.054970224899996, -123.869862556],
  'Nancy': [48.692100524902344, 6.230460166931152],
  'Nandi': [-17.755399703979492, 177.4429931640625],
  'Nanisivik': [72.982201, -84.613602],
  'Nantes': [47.153198242200006, -1.61073005199],
  'Naples': [40.886002, 14.2908],
  'Narssarssuaq': [61.1604995728, -45.4259986877],
  'Nashville': [36.1627, -86.7816],
  'Nassau': [25.0443, -77.3504],
  'Natashquan': [50.189998626708984, -61.78919982910156],
  'Nausori': [-18.04330062866211, 178.5590057373047],
  'Ndola': [-12.998100280762, 28.66489982605],
  'Nea Anghialos': [39.219600677490234, 22.794300079345703],
  'Negage': [-7.754509925842285, 15.287699699401855],
  'Negril': [18.2684, -78.3481],
  'Nejran': [17.611400604248047, 44.4192008972168],
  'Nelson': [-41.298301696777344, 173.2209930419922],
  'Nema': [16.621999740600586, -7.3165998458862305],
  'Nevatim': [31.208299636799996, 35.012298584],
  'Nevers': [47.002601623535156, 3.1133298873901367],
  'New Orleans': [29.9511, -90.0715],
  'New Plymouth': [-39.00859832763672, 174.1790008544922],
  'New York': [40.7128, -74.006],
  'Newark': [40.7357, -74.1724],
  'Newcastle': [55.037498474121094, -1.6916699409484863],
  'Newquai': [50.44060134887695, -4.995409965515137],
  'Niamey': [13.4815, 2.18361],
  'Niatougou': [9.767330169677734, 1.091249942779541],
  'Nice': [43.6584014893, 7.215869903560001],
  'Nimes': [43.75740051269531, 4.4163498878479],
  'Niort': [46.313477, -0.394529],
  'Nis': [43.337299, 21.853701],
  'Nogales': [31.22610092163086, -110.97599792480469],
  'Norderney': [53.70694351196289, 7.230000019073486],
  'Nordholz': [53.7677001953, 8.658499717709999],
  'Norman Wells': [65.28160095214844, -126.7979965209961],
  'Norman\'s Cay': [24.59429931640625, -76.82019805908203],
  'Norrkoeping': [58.586299896240234, 16.250600814819336],
  'North Battleford': [52.76919937133789, -108.24400329589844],
  'North Bay': [46.363602, -79.422798],
  'North Caicos': [21.9175, -71.939598],
  'North Eleuthera': [25.474899292, -76.6835021973],
  'Northolt': [51.553001403799996, -0.418166995049],
  'Norwich': [52.6758003235, 1.28278005123],
  'Nosara Beach': [9.976490020750001, -85.65299987790002],
  'Nosy-be': [-13.3121004105, 48.3148002625],
  'Notodden': [59.565701, 9.21222],
  'Nouadhibou': [20.9330997467041, -17.030000686645508],
  'Nouakschott': [18.31, -15.9697222],
  'Noumea': [-22.25830078125, 166.47300720214844],
  'Nuernberg': [49.498699, 11.078056],
  'Nueva Gerona': [21.834699630737305, -82.78379821777344],
  'Nuevo Casas Grandes': [30.3974, -107.875],
  'Nuevo Laredo': [27.4438991547, -99.5705032349],
  'Nuku Hiva': [-8.795599937438965, -140.22900390625],
  'Oakland': [37.8044, -122.2712],
  'Oamaru': [-44.970001220703125, 171.08200073242188],
  'Oaxaca': [16.9999008179, -96.726600647],
  'Oberpfaffenhofen': [48.081402, 11.2831],
  'Ocho Rios': [18.4057, -77.1049],
  'Odense': [55.47669982910156, 10.330900192260742],
  'Odiham': [51.2341003418, -0.94282501936],
  'Ohakea': [-40.20600128173828, 175.38800048828125],
  'Ohrid': [41.18, 20.7423],
  'Okondja': [-0.6652140021324158, 13.673100471496582],
  'Olbia': [40.898701, 9.51763],
  'Old Crow': [67.57060241699219, -139.83900451660156],
  'Omboue Hospial': [-1.5747300386428833, 9.262689590454102],
  'Omidyeh': [30.8351993560791, 49.5349006652832],
  'Oradea': [47.025299072265625, 21.90250015258789],
  'Oran': [35.54240036010742, -0.5322780013084412],
  'Orange': [44.140499114990234, 4.866720199584961],
  'Orebro': [59.22370147705078, 15.038000106811523],
  'Orland': [63.69889831542969, 9.604000091552734],
  'Orlando': [28.5383, -81.3792],
  'Orleans': [47.9878005981, 1.7605600357100002],
  'Ornskoldsvik': [63.40829849243164, 18.989999771118164],
  'Osijek': [45.46269989013672, 18.810199737548828],
  'Oskarshamn': [57.350498, 16.497999],
  'Oslo': [59.9139, 10.7522],
  'Ostend': [51.198898315399994, 2.8622200489],
  'Ostrava': [49.6963005065918, 18.111099243164062],
  'Ottawa': [45.3224983215332, -75.66919708251953],
  'Ouagadougou': [12.3532, -1.51242],
  'Ouargla': [31.917200088500977, 5.412779808044434],
  'Ouarzazate': [30.9391002655, -6.909430027010001],
  'Oudtshoorn': [-33.6069984436, 22.188999176],
  'Ouesso': [1.6159900426899998, 16.0379009247],
  'Oujda': [34.787200927734375, -1.92399001121521],
  'Oulu': [64.930099487305, 25.354600906372],
  'Ouvea': [-20.640600204467773, 166.572998046875],
  'Ovda': [29.94029998779297, 34.93579864501953],
  'Overberg': [-34.554901123, 20.250699996900003],
  'Owando': [-0.5313500165939331, 15.95009994506836],
  'Oxford': [51.8368988037, -1.32000005245],
  'Oyem': [1.5431100130081177, 11.581399917602539],
  'Ozamiz City': [8.1489, 123.8417],
  'Paderborn': [51.614101409899995, 8.616319656369999],
  'Padova': [45.395802, 11.8479],
  'Pagadian City': [7.8269, 123.4358],
  'Pago Pago': [-14.3310003281, -170.710006714],
  'Pailton': [51.668095, -2.05694],
  'Palermo': [38.175999, 13.091],
  'Palmar Sur': [8.951029777526855, -83.46859741210938],
  'Palmerston North': [-40.32059860229492, 175.61700439453125],
  'Pamplona': [42.77000045776367, -1.6463299989700317],
  'Panama': [8.973340034484863, -79.55560302734375],
  'Panama City': [8.9824, -79.5199],
  'Panglao': [9.5667, 123.75],
  'Pangnirtung': [66.1449966431, -65.71360015869999],
  'Pantelleria': [36.816502, 11.9689],
  'Paphos': [34.71799850463867, 32.48569869995117],
  'Paraparaumu': [-40.904701232910156, 174.98899841308594],
  'Parchim': [53.426998, 11.7834],
  'Pardubice': [50.01340103149414, 15.73859977722168],
  'Paris': [48.8566, 2.3522],
  'Parma': [44.824501, 10.2964],
  'Parnu': [58.41899871826172, 24.47279930114746],
  'Patras': [38.1511, 21.4256],
  'Patreksfjordur': [65.555801, -23.965],
  'Pau': [43.380001068115234, -0.41861099004745483],
  'Peace River': [56.226898, -117.446999],
  'Pelly Bay': [68.534401, -89.808098],
  'Pemba': [-12.991762161254883, 40.52401351928711],
  'Penticton': [49.46310043334961, -119.60199737548828],
  'Perigueux': [45.19810104370117, 0.815555989742279],
  'Perpignan': [42.74039840698242, 2.8706700801849365],
  'Perth': [-31.9505, 115.8605],
  'Perugia': [43.095901, 12.5132],
  'Pescara': [42.431702, 14.1811],
  'Petawawa': [45.95220184326172, -77.31919860839844],
  'Peterborough': [44.22999954223633, -78.36329650878906],
  'Phalaborwa': [-23.937200546299998, 31.1553993225],
  'Philadelphia': [39.9526, -75.1652],
  'Phoenix': [33.4484, -112.074],
  'Pickle Lake': [51.4463996887207, -90.21420288085938],
  'Pico': [38.554298, -28.441299],
  'Piedras Negras': [28.627399, -100.535004],
  'Piestany': [48.62519836425781, 17.828399658203125],
  'Pietermaritzburg': [-29.649000167799997, 30.3987007141],
  'Pilanesberg': [-25.333799362199997, 27.173400878900004],
  'Pinar Del Rio Norte': [22.42140007019043, -83.67839813232422],
  'Pisa': [43.683899, 10.3927],
  'Pittsburgh': [40.4406, -79.9959],
  'Plaisance': [-20.430201, 57.683601],
  'Plettenberg Bay': [-34.0881601675, 23.3287234306],
  'Plovdiv': [42.067799, 24.8508],
  'Plymouth': [50.422798, -4.10583],
  'Podgorica': [42.359402, 19.2519],
  'Pointe-noire': [-4.816030025482178, 11.88659954071045],
  'Poitiers': [46.58769989013672, 0.30666598677635193],
  'Pond Inlet': [72.6832962036, -77.9666976929],
  'Ponta Delgada': [37.7411994934, -25.6979007721],
  'Pontoise': [49.096667, 2.040833],
  'Poprad': [49.073600769, 20.2411003113],
  'Pori': [61.461700439453, 21.799999237061],
  'Port Antonio': [18.178, -76.4526],
  'Port Elizabeth': [-33.9849014282, 25.6173000336],
  'Port Gentil': [-0.7117390036582947, 8.754380226135254],
  'Port Hardy': [50.680599212646484, -127.36699676513672],
  'Port Hartcourt': [5.0154900550842285, 6.94959020614624],
  'Port Menier': [49.83639907836914, -64.2885971069336],
  'Port Moresby': [-9.443380355834961, 147.22000122070312],
  'Port Nelson': [23.68440055847168, -74.83619689941406],
  'Port of Spain': [10.6549, -61.5019],
  'Port Said': [31.279399871826172, 32.2400016784668],
  'Port Saint Johns': [-31.605899810791016, 29.519800186157227],
  'Port-au-prince': [18.579999923706055, -72.2925033569336],
  'Port-vila': [-17.699300765991, 168.32000732422],
  'Portage-la-prairie': [49.903099, -98.273817],
  'Portimao': [37.1493, -8.58396],
  'Portland': [45.5152, -122.6784],
  'Porto': [41.2481002808, -8.68138980865],
  'Porto Amboim': [-10.722000122070312, 13.76550006866455],
  'Porto Santo': [33.0733985901, -16.3500003815],
  'Portoroz': [45.4734001159668, 13.614999771118164],
  'Potchefstroom': [-26.670999527, 27.0818996429],
  'Potgietersrus': [-23.845269, 29.458615],
  'Poza Rico': [20.6026992798, -97.46080017090001],
  'Poznan': [52.421001434299995, 16.8262996674],
  'Prague': [50.1008, 14.26],
  'Praslin': [-4.3192901611328125, 55.69139862060547],
  'Prerov': [49.42580032348633, 17.404699325561523],
  'Prestwick': [55.5093994140625, -4.586669921875],
  'Pretoria': [-25.6539, 28.224199],
  'Preveza': [38.925498962402344, 20.765300750732422],
  'Prince Albert': [53.214199066199996, -105.672996521],
  'Prince George': [53.8894004822, -122.679000854],
  'Prince Pupert': [54.286098480199996, -130.445007324],
  'Principe': [1.6629400253295898, 7.411739826202393],
  'Pristina': [42.5728, 21.035801],
  'Propriano': [41.66059875488281, 8.889749526977539],
  'Providenciales': [21.7947, -72.2656],
  'Puebla': [19.1581001282, -98.3713989258],
  'Puerto Cabezas': [14.047200202941895, -83.38670349121094],
  'Puerto Escondido': [15.8769, -97.089103],
  'Puerto Plata': [19.75790023803711, -70.56999969482422],
  'Puerto Princesa': [9.7407, 118.7301],
  'Puerto Vallarta': [20.6534, -105.2253],
  'Puka Puka': [-14.809499740600586, -138.81300354003906],
  'Pukaki': [-44.2350006104, 170.117996216],
  'Pula': [44.89350128173828, 13.922200202941895],
  'Punta Cana': [18.567399978599997, -68.36340332030001],
  'Punta Penasco': [31.351987, -113.305177],
  'Quebec': [46.7911, -71.393303],
  'Queenstown': [-31.92020034790039, 26.882200241088867],
  'Queenstown International': [-45.0210990906, 168.738998413],
  'Quelimane': [-17.855499267578125, 36.86909866333008],
  'Quepos': [9.443160057067871, -84.12979888916016],
  'Queretaro': [20.6173, -100.185997],
  'Quesnel': [53.026100158691406, -122.51000213623047],
  'Quimper': [47.974998474121094, -4.167789936065674],
  'Quito': [-0.1807, -78.4678],
  'Quujjuaq': [58.096099853515625, -68.4269027709961],
  'Rabat': [34.051498, -6.75152],
  'Rafha': [29.626399993896484, 43.4906005859375],
  'Raiatea Island': [-16.7229, -151.466003],
  'Raleigh': [35.7796, -78.6382],
  'Ramon': [30.776100158691406, 34.66669845581055],
  'Ramstein': [49.4369010925293, 7.600279808044434],
  'Rangiroa': [-14.954299926757812, -147.66099548339844],
  'Rankin Inlet': [62.8114013672, -92.1157989502],
  'Reao': [-18.465900421142578, -136.44000244140625],
  'Rechlin-laerz': [53.306388855, 12.7522220612],
  'Red Deer Industrial': [52.18220138549805, -113.89399719238281],
  'Reggio Calabria': [38.071201, 15.6516],
  'Regina': [50.43190002441406, -104.66600036621094],
  'Reims': [49.310001, 4.05],
  'Rennes': [48.069499969499994, -1.73478996754],
  'Repulse Bay': [66.5214004517, -86.22470092770001],
  'Resolute': [74.7169036865, -94.9693984985],
  'Retalhuleu': [14.520999908447266, -91.69730377197266],
  'Reus': [41.14739990234375, 1.1671700477600098],
  'Reykjavik': [64.1299972534, -21.9405994415],
  'Reynosa': [26.0089, -98.2285],
  'Rhodos': [36.405399322509766, 28.086200714111328],
  'Richard\'s Bay': [-28.740999221800003, 32.0920982361],
  'Riesa': [51.2936096191, 13.3561105728],
  'Rijeka': [45.21689987182617, 14.570300102233887],
  'Rimini': [44.020302, 12.6117],
  'Rio de Janeiro': [-22.9068, -43.1729],
  'Riviere Du Loup': [47.764400482177734, -69.58470153808594],
  'Riyadh': [24.957599639892578, 46.69879913330078],
  'Roanne': [46.05830001831055, 4.001389980316162],
  'Roatan': [16.316799, -86.523003],
  'Robertson': [-33.812198638916016, 19.902799606323242],
  'Roberval': [48.52000045776367, -72.2656021118164],
  'Rochefort': [45.88779830932617, -0.9830560088157654],
  'Rock Sound': [24.8950787333, -76.1768817902],
  'Rocky Mountain House': [52.4296989441, -114.903999329],
  'Rodez': [44.407901763916016, 2.4826700687408447],
  'Rodriguez Island': [-19.7577, 63.361],
  'Rome': [41.9028, 12.4964],
  'Ronchi De Legionari': [45.827499, 13.4722],
  'Ronne': [55.06330108642578, 14.759599685668945],
  'Ronneby': [56.266700744629, 15.265000343323],
  'Roros': [62.578399658203, 11.342300415039],
  'Rosh Pina': [32.98099899291992, 35.5718994140625],
  'Rota': [36.645198822, -6.34946012497],
  'Rotorua': [-38.10919952392578, 176.31700134277344],
  'Rotterdam': [51.956902, 4.43722],
  'Rouen': [49.38420104980469, 1.1748000383377075],
  'Rouyn': [48.20610046386719, -78.83560180664062],
  'Rovaniemi': [66.564796447754, 25.830400466919],
  'Roxas City': [11.5854, 122.751],
  'Royan': [45.62810134887695, -0.9725000262260437],
  'Rurutu': [-22.434099197387695, -151.36099243164062],
  'Rygge': [59.378817, 10.785439],
  'Rzeszow': [50.1100006104, 22.0189990997],
  's': [17.1211, -61.8447],
  'Saarbruecken': [49.214599609400004, 7.10950994492],
  'Sachs Harbour': [71.9938964844, -125.242996216],
  'Sacramento': [38.5816, -121.4944],
  'Sainte Marie': [-17.093900680541992, 49.815799713134766],
  'Salamanca': [40.95209884643555, -5.501989841461182],
  'Salt Lake City': [40.7608, -111.891],
  'Saltillo': [25.54949951171875, -100.92900085449219],
  'Saltsy': [47.843056, 27.777222],
  'Salzburg': [47.793300628699996, 13.0043001175],
  'Sambava': [-14.278599739074707, 50.17470169067383],
  'Samedan': [46.53409957885742, 9.884110450744629],
  'Samos': [37.689998626708984, 26.911699295043945],
  'San Andros': [25.053800582885742, -78.04900360107422],
  'San Antonio': [29.4241, -98.4936],
  'San Diego': [32.7157, -117.1611],
  'San Filipe': [30.930200576782, -114.80899810791],
  'San Francisco': [37.7749, -122.4194],
  'San Jose': [12.3525, 121.0682],
  'San Jose CA': [37.3382, -121.8863],
  'San Jose CR': [9.9281, -84.0907],
  'San Jose Del Cabo': [23.15180015563965, -109.72100067138672],
  'San Luis Potosi': [22.254299163800003, -100.930999756],
  'San Pedro': [4.746719837188721, -6.660820007324219],
  'San Pedro Sula': [15.4526, -87.923599],
  'San Salvador': [13.6929, -89.2182],
  'San Sebastian': [43.35649871826172, -1.7906099557876587],
  'San Vito De Jaba': [8.826109886169434, -82.95890045166016],
  'Sanandaj': [35.24589920043945, 47.00920104980469],
  'Sancti Spiritus': [21.9704, -79.442703],
  'Sandefjord': [59.1866989136, 10.258600235],
  'Sandnessjoen': [65.956802368164, 12.468899726868],
  'Sandspit': [53.25429916379999, -131.813995361],
  'Sanford': [28.8, -81.2667],
  'Santa Ana': [33.7455, -117.8677],
  'Santa Clara': [22.49220085144043, -79.943603515625],
  'Santa Cruz De La Palma': [28.626499, -17.7556],
  'Santa Maria (island)': [36.97140121459961, -25.17060089111328],
  'Santander': [43.427101135253906, -3.82000994682312],
  'Santiago': [-33.4489, -70.6693],
  'Santiago De Cuba': [19.96980094909668, -75.83540344238281],
  'Santo Domingo': [18.42970085144, -69.668899536133],
  'Sao Jorge Island': [38.66550064086914, -28.175800323486328],
  'Sao Nocolau Island': [16.58839988708496, -24.284700393676758],
  'Sao Paulo': [-23.5505, -46.6333],
  'Sao Tome': [0.3781749904155731, 6.7121500968933105],
  'Sao Vicente Island': [16.833200454711914, -25.055299758911133],
  'Sarajevo': [43.82460021972656, 18.331499099731445],
  'Sarnia': [42.9994010925293, -82.30889892578125],
  'Saskatoon': [52.170799255371094, -106.69999694824219],
  'Satu Mare': [47.70330047607422, 22.885700225830078],
  'Sault Sainte Marie': [46.48500061035156, -84.5093994140625],
  'Saurimo': [-9.689069747924805, 20.431900024414062],
  'Savonlinna': [61.943099975586, 28.945100784302],
  'Scampton': [53.307800293, -0.550832986832],
  'Scarborough': [11.1829, -60.7382],
  'Scatsta': [60.43280029296875, -1.2961100339889526],
  'Schefferville': [54.805301666259766, -66.8052978515625],
  'Schleswig': [54.459301, 9.51633],
  'Schoenhagen': [52.203609, 13.156389],
  'Seattle': [47.6062, -122.3321],
  'Sebha': [26.98699951171875, 14.47249984741211],
  'Secunda': [-26.52409935, 29.170099258399997],
  'Selebi-phikwe': [-22.0583, 27.8288],
  'Selibabi': [15.179699897766113, -12.207300186157227],
  'Seo De Urgel': [42.3386, 1.40917],
  'Seoul': [37.5665, 126.978],
  'Sept-iles': [50.22330093383789, -66.2656021118164],
  'Sevilla': [37.17490005493164, -5.615940093994141],
  'Sfax': [34.71799850463867, 10.690999984741211],
  'Shanghai': [31.2304, 121.4737],
  'Shannon': [52.702, -8.92482],
  'Sharurah': [17.466899871826172, 47.12139892578125],
  'Shenzhen': [22.5431, 114.0579],
  'Sherbrooke': [45.4385986328125, -71.69139862060547],
  'Shindand': [33.3913002014, 62.2610015869],
  'Shoreham By Sea': [50.835602, -0.297222],
  'Siargao': [9.86, 126.0467],
  'Sibiu': [45.78559875488281, 24.091299057006836],
  'Sidi Bel Abbes': [35.1717987061, -0.593275010586],
  'Siegerland': [50.707698822021484, 8.082969665527344],
  'Siena': [43.256302, 11.255],
  'Siglufjordur': [66.133301, -18.9167],
  'Sigonella': [37.401699, 14.9224],
  'Siguanea': [21.642499923706055, -82.9551010131836],
  'Siirt': [37.97890090942383, 41.84040069580078],
  'Singapore': [1.3521, 103.8198],
  'Sion': [46.219600677500004, 7.326759815220001],
  'Sioux Lookout': [50.11389923095703, -91.9052963256836],
  'Siri Island': [25.908899307250977, 54.539398193359375],
  'Sishen': [-27.6485996246, 22.9993000031],
  'Sitia': [35.21609878540039, 26.101299285888672],
  'Sivas': [39.813801, 36.9035],
  'Skelleftea': [64.62480163574219, 21.076900482177734],
  'Skiathos': [39.177101135253906, 23.503700256347656],
  'Skien': [59.185001373291016, 9.566940307617188],
  'Skiros': [38.9676017761, 24.4871997833],
  'Skive': [56.550201416015625, 9.172980308532715],
  'Skopje': [41.961601, 21.621401],
  'Skovde': [58.45640182495117, 13.972700119018555],
  'Skrydstrup': [55.221048, 9.26702],
  'Skukuza': [-24.960899353, 31.5886993408],
  'Slave Lake': [55.2930984497, -114.777000427],
  'Sliac': [48.63779830932617, 19.13409996032715],
  'Sligo': [54.280200958252, -8.5992097854614],
  'Slupsk': [54.47890090942383, 17.107500076293945],
  'Smithers': [54.82469940185547, -127.18299865722656],
  'Sodankyla': [67.3949966431, 26.6191005707],
  'Soenderborg': [54.96440124511719, 9.791729927062988],
  'Soesterberg': [52.1273002625, 5.27618980408],
  'Sofia': [42.696693420410156, 23.411436080932617],
  'Sokoto': [12.916299819946289, 5.207190036773682],
  'Solenzara': [41.924400329589844, 9.406000137329102],
  'Sondrestrom': [67.0122218992, -50.7116031647],
  'Soroti': [1.7276899814605713, 33.622798919677734],
  'South Caicos': [21.515699386599998, -71.528503418],
  'Southampton': [50.95029830932617, -1.3567999601364136],
  'Southdowns': [-12.900500297546387, 28.149900436401367],
  'Southend': [51.5713996887207, 0.6955559849739075],
  'Soyo': [-6.141089916229248, 12.371800422668457],
  'Spangdahlem': [49.9726982117, 6.69250011444],
  'Sparti': [36.973899841308594, 22.52630043029785],
  'Spence Bay': [69.5466995239, -93.5766983032],
  'Split': [43.53889846801758, 16.29800033569336],
  'Spring Point': [22.441799163800003, -73.97090148930002],
  'Springbok': [-29.689300537109375, 17.939599990844727],
  'St-Etienne': [45.54059982299805, 4.296390056610107],
  'St. Anthony': [51.3918991089, -56.083099365200006],
  'St. Catherine': [28.685300827, 34.0625],
  'St. Jean': [45.29439926147461, -73.28109741210938],
  'St. John': [45.31610107421875, -65.89029693603516],
  'St. John\'s': [47.618598938, -52.7518997192],
  'St. Louis': [38.627, -90.1994],
  'St. Maarten': [18.0425, -63.0548],
  'St.-brieuc Armor': [48.5378, -2.85444],
  'St.-denis': [-20.887100219726562, 55.51029968261719],
  'St.-nazaire': [47.3105556, -2.1566667],
  'St.-pierre': [-21.320899963378906, 55.42499923706055],
  'St.-yan': [46.412498474121094, 4.0132598876953125],
  'Staniel Cay': [24.169099807739258, -76.43910217285156],
  'Stara Zagora': [42.3766667, 25.655],
  'Stauning': [55.9901008605957, 8.353910446166992],
  'Stavanger': [58.876701354, 5.6377801895],
  'Stella Maris': [23.582317, -75.268621],
  'Stephenville': [48.5442008972168, -58.54999923706055],
  'Stockholm': [59.3293, 18.0686],
  'Stord': [59.791900634765625, 5.340849876403809],
  'Stornoway': [58.215599060058594, -6.331110000610352],
  'Strasbourg': [48.538299560546875, 7.628230094909668],
  'Straubing': [48.90083312988281, 12.516667366027832],
  'Stuttgart': [48.689899444599995, 9.22196006775],
  'Subic Bay': [14.8774, 120.2726],
  'Suceava': [47.6875, 26.35409927368164],
  'Sudbury': [46.625, -80.79889678955078],
  'Sulayel': [20.46470069885254, 45.619598388671875],
  'Sumburgh': [59.87889862060547, -1.2955600023269653],
  'Summerside': [46.44060134887695, -63.83359909057617],
  'Sundsvall': [62.528099060058594, 17.443899154663086],
  'Sunyani': [7.361830234527588, -2.3287599086761475],
  'Surigao City': [9.7842, 125.4911],
  'Svalbard': [78.246101379395, 15.465600013733],
  'Sveg': [62.04779815673828, 14.422900199890137],
  'Swansea': [51.60530090332031, -4.0678300857543945],
  'Swift Current': [50.291900634799994, -107.691001892],
  'Sydney': [-33.8688, 151.2093],
  'Szczecin': [53.584701538100006, 14.902199745199999],
  'Tabiteuea North': [-1.2244700193405151, 174.7760009765625],
  'Tabuk': [28.3654, 36.6189],
  'Tacloban City': [11.2443, 125.0038],
  'Tahoua': [14.875699996948242, 5.265359878540039],
  'Taif': [21.483001, 40.543442],
  'Taipei': [25.033, 121.5654],
  'Takapoto': [-14.709500312805176, -145.24600219726562],
  'Takaroa': [-14.45580005645752, -145.02499389648438],
  'Takoradi': [4.896059989929199, -1.7747600078582764],
  'Tallinn-ulemiste International': [59.41329956049999, 24.832799911499997],
  'Tamale': [9.55718994140625, -0.8632140159606934],
  'Tamanrasset': [22.8115005493, 5.45107984543],
  'Tambacounda': [13.736800193786621, -13.65310001373291],
  'Tampa': [27.9506, -82.4572],
  'Tampere': [61.414100646973, 23.604400634766],
  'Tampico': [22.2964000702, -97.8658981323],
  'Tamuin': [22.0383, -98.806502],
  'Tan Tan': [28.448200225830078, -11.161299705505371],
  'Tanga': [-5.092360019683838, 39.07120132446289],
  'Tanger': [35.726898193400004, -5.91689014435],
  'Tapachula': [14.7943000793, -92.3700027466],
  'Tarawa': [1.3816399574279785, 173.14700317382812],
  'Tarbes': [43.1786994934082, -0.006438999902456999],
  'Tartu': [58.3074989319, 26.690399169900004],
  'Taupo': [-38.73970031738281, 176.08399963378906],
  'Tauranga': [-37.67190170288086, 176.1959991455078],
  'Tebessa': [35.4315986633, 8.12071990967],
  'Teesside': [54.50920104980469, -1.4294099807739258],
  'Tegucigalpa': [14.06089973449707, -87.21720123291016],
  'Tehuacan': [18.49720001220703, -97.4198989868164],
  'Tel-aviv': [32.01139831542969, 34.88669967651367],
  'Tela': [15.7759, -87.4758],
  'Tenerife': [28.044500351, -16.5725002289],
  'Tepic': [21.4195, -104.843002],
  'Terrace': [54.468498, -128.576009],
  'Teslin': [60.17279815673828, -132.7429962158203],
  'Tete': [-16.104799270629883, 33.640201568603516],
  'Tetouan': [35.594299316406, -5.320020198822],
  'Thessaloniki': [40.51969909667969, 22.97089958190918],
  'Thira': [36.399200439453125, 25.479299545288086],
  'Thisted': [57.06880187988281, 8.705220222473145],
  'Thompson': [55.80110168457031, -97.86419677734375],
  'Thule': [76.5311965942, -68.7032012939],
  'Thunder Bay': [48.37189865112305, -89.32389831542969],
  'Tiaret': [35.3410987854, 1.46315002441],
  'Tidjikja': [18.570100784301758, -11.423500061035156],
  'Tijuana': [32.541099548339844, -116.97000122070312],
  'Tikehau': [-15.119600296020508, -148.2310028076172],
  'Tiko': [4.08919000626, 9.360529899600001],
  'Tilrempt': [32.93040084838867, 3.311539888381958],
  'Timaru': [-44.302799224853516, 171.22500610351562],
  'Timimoun': [29.2371006012, 0.276033014059],
  'Timisoara': [45.809898376464844, 21.337900161743164],
  'Timmins': [48.569698333699996, -81.376701355],
  'Tindouf': [27.7003993988, -8.167099952700001],
  'Tirana': [41.4146995544, 19.7206001282],
  'Tiree': [56.49919891357422, -6.869170188903809],
  'Tirgu Mures': [46.46770095825195, 24.412500381469727],
  'Tivat': [42.404701232910156, 18.72330093383789],
  'Tlemcen': [35.0167007446, -1.45000004768],
  'Toamasina': [-18.109500885009766, 49.39250183105469],
  'Tofino': [49.079833, -125.775583],
  'Tokat': [40.307430267333984, 36.367408752441406],
  'Tokyo': [35.6895, 139.6917],
  'Tolagnaro': [-25.03809928894043, 46.95610046386719],
  'Toliara': [-23.383399963378906, 43.72850036621094],
  'Toluca': [19.3370990753, -99.56600189210002],
  'Tombouctou': [16.730499267578125, -3.007580041885376],
  'Tongatapu': [-21.241199493408203, -175.14999389648438],
  'Topel': [40.73500061035156, 30.08329963684082],
  'Torino': [45.200802, 7.64963],
  'Toronto': [43.6532, -79.3832],
  'Torreon': [25.568300247199996, -103.411003113],
  'Tortoli': [39.9188, 9.68298],
  'Totegegie': [-23.07990074157715, -134.88999938964844],
  'Touggourt': [33.06779861450195, 6.088669776916504],
  'Touho': [-20.790000915527344, 165.25900268554688],
  'Toulouse': [43.629101, 1.36382],
  'Tours': [47.4322013855, 0.727605998516],
  'Toussous-le-noble': [48.75189971923828, 2.1061899662017822],
  'Tozeur': [33.939701080322266, 8.110560417175293],
  'Trabzon': [40.99509811401367, 39.78969955444336],
  'Trapani': [37.9114, 12.488],
  'Treasure Cay': [26.745300293, -77.3912963867],
  'Trenton': [44.118900299072266, -77.5280990600586],
  'Treviso': [45.648399, 12.1944],
  'Tripoli': [32.6635017395, 13.1590003967],
  'Trollhattan': [58.31809997558594, 12.345000267028809],
  'Tromso': [69.68329620361328, 18.918899536132812],
  'Trondheim': [63.4578018, 10.9239998],
  'Trujillo': [15.9268, -85.938202],
  'Tubuai': [-23.365400314331055, -149.5240020751953],
  'Tuguegarao City': [17.6132, 121.727],
  'Tuktoyaktuk': [69.43329620361328, -133.0260009765625],
  'Tulcea': [45.0625, 28.71430015563965],
  'Tunis': [36.85100173950195, 10.22719955444336],
  'Turaif': [31.692188, 38.731544],
  'Turku': [60.514099121094, 22.262800216675],
  'Tuxtla Gutierrez': [16.5636005402, -93.02249908450001],
  'Tzaneen': [-23.8243999481, 30.329299926799997],
  'Uige': [-7.60306978225708, 15.027799606323242],
  'Ulundi': [-28.3206005096, 31.4165000916],
  'Umea': [63.791801452637, 20.282800674438],
  'Umtata': [-31.546363184900002, 28.6733551025],
  'Upington': [-28.39909935, 21.260200500499998],
  'Uruapan': [19.396699905395508, -102.03900146484375],
  'Utti': [60.89640045166, 26.938400268555],
  'Vaasa': [63.050701141357, 21.762199401855],
  'Vagar': [62.0635986328125, -7.277219772338867],
  'Val D\'or': [48.0532989502, -77.7827987671],
  'Valence': [44.9216, 4.9699],
  'Valencia': [39.4893, -0.481625],
  'Valenciennes': [50.325801849365234, 3.4612600803375244],
  'Valkenburg': [52.166099548300004, 4.41794013977],
  'Valladolid': [41.7061004639, -4.85194015503],
  'Van': [38.46820068359375, 43.332298278808594],
  'Vancouver': [49.2827, -123.1207],
  'Vannes': [47.72330093383789, -2.718559980392456],
  'Varadero': [23.034400939941406, -81.435302734375],
  'Varkaus': [62.171100616455, 27.868600845337],
  'Varna': [43.232101, 27.8251],
  'Vasteras': [59.58940124511719, 16.63360023498535],
  'Vava\'u': [-18.58530044555664, -173.96200561523438],
  'Vaxjo': [56.929100036621094, 14.727999687194824],
  'Venice': [45.4408, 12.3155],
  'Vera Cruz': [19.1459007263, -96.1873016357],
  'Vermillion': [53.355800628699996, -110.823997498],
  'Vesivehmaa': [61.144199, 25.693501],
  'Vestmannaeyjar': [63.42430114746094, -20.278900146484375],
  'Vicenza': [45.573399, 11.5295],
  'Vichy': [46.169700622558594, 3.4037399291992188],
  'Victoria': [48.646900177, -123.426002502],
  'Victoria Falls': [-18.09589958190918, 25.839000701904297],
  'Vienna': [48.2082, 16.3738],
  'Vieux Fort': [13.7333, -60.95],
  'Vigo': [42.2318000793457, -8.62677001953125],
  'Vila Real': [41.2743, -7.72047],
  'Vilankulu': [-22.018400192260742, 35.31330108642578],
  'Vilhelmina': [64.5791015625, 16.833599090576172],
  'Villacoublay': [48.7741667, 2.1916667],
  'Villafranca': [45.395699, 10.8885],
  'Villahermosa': [17.996999740600586, -92.81739807128906],
  'Virac': [13.5833, 124.2333],
  'Visby': [57.662799835205, 18.346200942993],
  'Viseu': [40.725498, -7.88899],
  'Vitoria': [42.8828010559082, -2.7244699001312256],
  'Vodochody': [50.216599, 14.3958],
  'Vohemar': [-13.375800132751465, 50.00279998779297],
  'Vredendal': [-31.641000747680664, 18.5447998046875],
  'Vryburg': [-26.9824008942, 24.7287998199],
  'Wabush': [52.92190170288086, -66.8644027709961],
  'Waddington': [53.1661987305, -0.523810982704],
  'Wairoa': [-39.006900787353516, 177.40699768066406],
  'Wajir': [1.73324, 40.091599],
  'Wallis': [-13.2383003235, -176.199005127],
  'Wanaka': [-44.722198486328, 169.24600219727],
  'Wanganui': [-39.96220016479492, 175.02499389648438],
  'Warsaw': [52.1656990051, 20.967100143399996],
  'Warton': [53.745098, -2.88306],
  'Washington D.C.': [38.9072, -77.0369],
  'Waterford': [52.187198638916016, -7.0869598388671875],
  'Waterkloof': [-25.829999923699997, 28.222499847399998],
  'Waterloo': [43.460800170899994, -80.3786010742],
  'Watson Lake': [60.11640167236328, -128.82200622558594],
  'Wejh': [26.19860076904297, 36.47639846801758],
  'Wellington': [-41.2865, 174.7762],
  'West Palm Beach': [26.7153, -80.0534],
  'Westerland': [54.9132003784, 8.34047031403],
  'Westport': [-41.73809814453125, 171.58099365234375],
  'Wewak': [-3.58383011818, 143.669006348],
  'Whakatane': [-37.92060089111328, 176.91400146484375],
  'Whangarei': [-35.7682991027832, 174.36500549316406],
  'Whitecourt': [54.14390182495117, -115.78700256347656],
  'Whitehorse': [60.7095985413, -135.067001343],
  'Wiarton': [44.7458, -81.107201],
  'Wick': [58.458900451660156, -3.09306001663208],
  'Wide Awake': [-7.9696, -14.3937],
  'Wiesbaden': [50.049800872802734, 8.325400352478027],
  'Wilhelmshaven': [53.502220153808594, 8.05222225189209],
  'Williams Lake': [52.1831016541, -122.054000854],
  'Windsor': [42.27560043334961, -82.95559692382812],
  'Winnipeg': [49.909999847399995, -97.2398986816],
  'Woensdrecht': [51.4491, 4.34203],
  'Woodbourne': [-41.5182991027832, 173.8699951171875],
  'Wrigley': [63.20940017700195, -123.43699645996094],
  'Wroclaw': [51.1026992798, 16.885799408],
  'Wyton': [52.3572006226, -0.107832998037],
  'Xangongo': [-16.755399703979492, 14.965299606323242],
  'Yamoussoukro': [6.9031701088, -5.36558008194],
  'Yaounde': [3.8360400199890137, 11.523500442504883],
  'Yellowknife': [62.462799072265625, -114.44000244140625],
  'Yenbo': [24.144199, 38.0634],
  'Yeovilton': [51.0093994140625, -2.638819932937622],
  'Ylivieska-raudaskyla': [64.0547222, 24.7252778],
  'Yola': [9.257550239562988, 12.430399894714355],
  'Yorkton': [51.26470184326172, -102.46199798583984],
  'Zacatecas': [22.8971004486, -102.68699646],
  'Zadar': [44.108299, 15.3467],
  'Zagreb': [45.7429008484, 16.0687999725],
  'Zakynthos': [37.7509, 20.8843],
  'Zamboanga City': [6.91, 122.07],
  'Zamora': [20.045, -102.276001],
  'Zanzibar': [-6.22202, 39.224899],
  'Zaragoza': [41.66619873046875, -1.0415500402450562],
  'Zaria': [11.1302, 7.68581],
  'Zarzaitine': [28.0515, 9.64291],
  'Zielona Gora': [52.138500213600004, 15.7986001968],
  'Ziguinchor': [12.5556, -16.281799],
  'Zihuatanejo': [17.601600647, -101.460998535],
  'Zinder': [13.779000282287598, 8.983759880065918],
  'Zoersel': [51.264702, 4.75333],
  'Zurich': [47.3769, 8.5417],
  'Zweibruecken': [49.2094, 7.40056]
};